/* ============================================================================
   NOTAS DE CREDITO Y DEBITO — Portal Kennedy
   ---------------------------------------------------------------------------
   El vendedor levanta la solicitud desde una factura: el portal trae el
   cliente, el vendedor, el pais, la fecha y las lineas, y el vendedor solo
   corrige lo que haga falta. TODO lo que se rellena solo se puede editar.

   Dos formas de calcular el monto:

     - Por lineas: se marcan los articulos que no llegaron o llegaron mal y el
       monto sale de la factura (cantidad afectada x precio neto de la linea).
       El grupo contable lo pone el sistema, articulo por articulo, igual que
       dice el formulario en papel.

     - Por monto: pronto pago, cargo bancario, traslado de saldo. No hay
       lineas; se escribe el monto y hay que elegir el grupo a mano.

   La nota vive entera dentro del portal: se guarda en `solicitudes_nota`, el
   administrador la aprueba y se imprime o se descarga en PDF con el mismo
   formato del formulario en papel. No toca SAP.

   Prefijo `ncr` / `NCR_`: `nc` ya lo usa el modulo de Nuevo Cliente.
============================================================================ */

// ── Motivos ─────────────────────────────────────────────────────────────────
// SALEN DE SAP, de la tabla OSHP, que el worker copia a `motivos_nota`.
//
// Antes estaban escritos a mano aqui y no coincidian: el portal decia
// «MERCANCIA DEFECTUOSA» y SAP «MERCANCIA DEFECTUOSA O DAÑADA», «ERROR EN
// PRECIOS» contra «ERROR EN PRECIO», y cinco mas. Al mandar la nota, SAP no
// reconocia el motivo y el documento salia sin el.
//
// Las listas de abajo son solo el RESPALDO para cuando aun no se ha cargado
// la tabla; en cuanto llega la de SAP, se reemplazan.
var NCR_MOTIVOS_CREDITO = [
  'MERCANCIA DEFECTUOSA O DAÑADA', 'FALTANTE DE MERCANCIA',
  'DEVOLUCION DE MERCANCIA', 'ERROR EN DESPACHO', 'ERROR EN PRECIO',
  'ERROR EN FACTURACION', 'DESCUENTO ESPECIAL', 'DESCUENTO POR PRONTO PAGO',
  'CARGO BANCARIO', 'TRASLADO DE SALDO', 'ERROR EN CARGO A LA CUENTA', 'OTROS'
];
var NCR_MOTIVOS_DEBITO = [
  'CARGO DHL', 'CARGO BANCARIO', 'PAGO DE DOCUMENTO (TRASPASO)',
  'CHEQUE DEVUELTO', 'ANULACION DE FACTURA', 'OTROS'
];
var NCR_MOTIVOS_POR_LINEA = [
  'MERCANCIA DEFECTUOSA O DAÑADA', 'FALTANTE DE MERCANCIA',
  'DEVOLUCION DE MERCANCIA', 'ERROR EN DESPACHO', 'ERROR EN PRECIO',
  'ERROR EN FACTURACION'
];

// El codigo de SAP de cada motivo. Se guarda en la nota para que al enviarla
// no haya que buscarlo por nombre.
var NCR_MOTIVO_COD = {};
var NCR_MOTIVOS_OK = false;

async function ncrCargarMotivos(){
  if(NCR_MOTIVOS_OK) return;
  try{
    var r = await q('motivos_nota',
      'select=trnspcode,nombre,por_linea&activo=is.true&order=orden') || [];
    if(!r.length) return;        // sin datos se queda el respaldo
    NCR_MOTIVO_COD = {};
    var todos = [], porLinea = [];
    r.forEach(function(x){
      var n = String(x.nombre||'').trim();
      if(!n) return;
      todos.push(n);
      NCR_MOTIVO_COD[n] = x.trnspcode;
      if(x.por_linea) porLinea.push(n);
    });
    if(!todos.length) return;
    // SAP tiene UNA lista para los dos tipos. Se ofrece entera: que un
    // motivo valga o no para una nota de debito lo sabe quien la crea, y
    // esconderle opciones que SAP si acepta solo estorba.
    NCR_MOTIVOS_CREDITO = todos;
    NCR_MOTIVOS_DEBITO  = todos;
    NCR_MOTIVOS_POR_LINEA = porLinea;
    NCR_MOTIVOS_OK = true;
  }catch(e){
    try{ console.warn('[notas] no pude traer los motivos de SAP:', e); }catch(_){}
  }
}


var NCR_GRUPOS = [
  {v:'4002-001', t:'OTROS'},
  {v:'4002-004', t:'GRUPO DE ALFOMBRA'},
  {v:'4002-005', t:'GRUPO DE CALZADO'},
  {v:'4002-006', t:'GRUPO DE CONSTRUCCION'},
  {v:'4002-007', t:'GRUPO DE ELECTRONICA'},
  {v:'4002-008', t:'GRUPO DE HOGAR'},
  {v:'4002-009', t:'GRUPO DE MUEBLE'},
  {v:'4002-010', t:'GRUPO DE ROPA'}
];

// Que le paso a la linea. Sale en el PDF junto a cada articulo.
var NCR_CONDICIONES = [
  'NO LLEGO', 'LLEGO EN MAL ESTADO', 'LLEGO INCOMPLETO',
  'NO CORRESPONDE AL PEDIDO', 'ERROR DE PRECIO', 'OTRO'
];

var NCR_ESTADOS = {
  borrador : {t:'Borrador',  c:'b-gray'},
  pendiente: {t:'Pendiente', c:'b-amber'},
  aprobada : {t:'Aprobada',  c:'b-green'},
  rechazada: {t:'Rechazada', c:'b-red'},
  anulada  : {t:'Anulada',   c:'b-gray'}
};


// ── Utilidades propias ──────────────────────────────────────────────────────
// Escape propio para no depender del orden en que carguen los archivos.
function ncrEsc(s){
  return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}
function ncrNum(v){ var n=parseFloat(v); return isFinite(n)?n:0; }
function ncrMon(n){ return '$'+ncrNum(n).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); }
function ncrHoy(){ return new Date().toISOString().slice(0,10); }
function ncrYo(){
  try{ return (typeof CU!=='undefined'&&CU) ? (CU.email||CU.username||CU.nombre||'portal') : 'portal'; }
  catch(e){ return 'portal'; }
}
function ncrRol(){
  try{ return String((typeof CU!=='undefined'&&CU&&CU.rol)||'').toLowerCase(); }
  catch(e){ return ''; }
}
function ncrPuedeVer(){    var r=ncrRol(); return r!=='' && r!=='cliente'; }
function ncrPuedeCrear(){  var r=ncrRol(); return ['vendedor','admin','administrador','gerencia'].indexOf(r)>=0; }
// ── El circuito de la nota ────────────────────────────────────────────
//   vendedor crea      -> pendiente
//   Dan o Jimmy revisan-> revisada    (le llega a contabilidad)
//   Joselyn aprueba    -> aprobada    (con el Sr. Saul)
//   Joselyn o Dan      -> enviada     (se crea en SAP)
//
// Joselyn entra como VENDEDOR, asi que el permiso no puede salir del rol:
// va por su usuario, igual que la lista de quien ve margenes.
var NCR_CONTABILIDAD_USR = ['contabilidad2','joselyn'];
var NCR_ENVIAN_SAP       = ['contabilidad2','joselyn','dan'];

// Se mira el nombre de usuario Y el correo completo. Si en el portal el
// usuario se llama de otra forma que el correo, por una sola de las dos no se
// le reconoceria y se quedaria sin el boton sin saber por que.
function ncrUsuario(){
  try{ return String((CU&&(CU.username||String(CU.email||'').split('@')[0]))||'').toLowerCase(); }
  catch(e){ return ''; }
}
function ncrEsUno(lista){
  var u=ncrUsuario();
  var c=''; try{ c=String((CU&&CU.email)||'').toLowerCase(); }catch(e){}
  var cp=c.split('@')[0];
  for(var i=0;i<lista.length;i++){
    var k=String(lista[i]).toLowerCase();
    if(u===k || cp===k || c===k) return true;
  }
  return false;
}
// Revisar: el primer filtro, lo que hoy hacen Dan y Jimmy.
function ncrPuedeRevisar(){
  return ['admin','administrador','gerencia'].indexOf(ncrRol())>=0;
}
// Aprobar: contabilidad. Y administracion, que puede hacerlo todo.
function ncrPuedeAprobar(){
  return ['admin','administrador'].indexOf(ncrRol())>=0
      || ncrEsUno(NCR_CONTABILIDAD_USR);
}
// Mandar a SAP: solo Joselyn y Dan. Es el paso que crea el asiento contable.
function ncrPuedeEnviarSap(){
  return ncrEsUno(NCR_ENVIAN_SAP);
}
// Borrar una nota es distinto de anularla: se lleva por delante el historial y
// los adjuntos. Solo gerencia y administracion, y nunca contabilidad, que
// aprueba pero no debe poder hacer desaparecer lo que aprobo.
function ncrPuedeBorrar(){
  return ['admin','administrador','gerencia'].indexOf(ncrRol())>=0;
}

// Nombre del grupo a partir del codigo 4002-XXX.
function ncrGrupoNombre(cod){
  for(var i=0;i<NCR_GRUPOS.length;i++) if(NCR_GRUPOS[i].v===cod) return NCR_GRUPOS[i].t;
  return '';
}

// Deduce el grupo contable a partir del grupo/departamento del articulo. No
// pretende acertar siempre: por eso el campo del formulario queda editable.
function ncrGrupoDeTexto(txt){
  var s=String(txt||'').toUpperCase();
  if(/ALFOMBRA|TAPETE|GRAMA/.test(s))                                  return '4002-004';
  if(/CALZADO|ZAPAT|SANDALIA|BOTA|TACON|CHANCLETA|PANTUNFLA/.test(s))  return '4002-005';
  if(/CONSTRUC|PORCELANATO|CERAMIC|AZULEJO|GRANITO|MARMOL|MOSAICO|PISO|ALUMINIO|TECHO|INODORO|LAVAMANO|GRIFO|DUCHA/.test(s)) return '4002-006';
  if(/ELECTRO|TELEVISOR|LICUADORA|NEVERA|MICROONDA|ABANICO|BOCINA|FREIDORA|PLANCHA|AUDIO|REFRIGERA/.test(s)) return '4002-007';
  if(/HOGAR|COCINA|BANO|BA\u00d1O|TEXTIL|DECORA|TOALLA|SABANA|CORTINA|VAJILLA|UTENSILIO|ORGANIZA/.test(s))  return '4002-008';
  if(/MUEBLE|SOFA|COLCHON|CAMA|SILLA|MESA|ESCRITORIO|GAVETERO|ARMARIO|COMEDOR/.test(s))                     return '4002-009';
  if(/ROPA|CAMISA|PANTALON|VESTIDO|BLUSA|JEANS|SWEATER|PIJAMA|SHORT|FALDA|T-SHIRT/.test(s))                 return '4002-010';
  return '4002-001';
}

// El precio que el cliente pago de verdad por unidad. Se saca del total de la
// linea entre la cantidad y no del campo `price`, porque en SAP `Price` ya
// viene con el descuento aplicado unas veces y otras no.
function ncrPrecioNeto(l){
  var c=ncrNum(l.quantity), t=ncrNum(l.linetotal);
  if(c>0 && isFinite(t)) return t/c;
  var p=ncrNum(l.price), d=ncrNum(l.descuentolinea);
  return (d>0&&d<100) ? p*(1-d/100) : p;
}

// Insert / update contra PostgREST. Se usa el mismo patron que la cola de
// autorizaciones: token del usuario, y si falla se devuelve el texto del error.
async function ncrEscribir(metodo, ruta, cuerpo){
  var r = await fetch(SB+'/rest/v1/'+ruta, {
    method: metodo,
    headers: {'apikey':KEY, 'Authorization':'Bearer '+AUTHTOK(),
              'Content-Type':'application/json', 'Prefer':'return=representation'},
    body: cuerpo ? JSON.stringify(cuerpo) : undefined
  });
  var txt = await r.text();
  if(!r.ok) throw new Error(txt.slice(0,300) || ('HTTP '+r.status));
  try{ return txt ? JSON.parse(txt) : []; }catch(e){ return []; }
}

function ncrMsg(txt, tipo){
  var m=document.getElementById('ncr-msg'); if(!m) return;
  if(!txt){ m.style.display='none'; m.innerHTML=''; return; }
  var col = tipo==='ok' ? 'var(--green)' : (tipo==='err' ? 'var(--red)' : 'var(--text2)');
  m.style.display='block';
  m.style.cssText='display:block;margin:10px 0;padding:10px 13px;border-radius:var(--r2);'
    +'font-size:13px;border:1px solid var(--border);background:var(--surface2);color:'+col;
  m.innerHTML=txt;
}


/* ══════════════════════════════════════════════════════════════════════════
   LISTA
   ══════════════════════════════════════════════════════════════════════════ */

var NCR_LISTA = [], NCR_FILTRO = {estado:'', texto:''};

// go('notas') llama a ncrInit() 50 ms despues de cambiar de pagina. Cuando
// venimos de "Nueva nota" o del detalle, la pantalla YA quedo pintada y ese
// ncrInit tardio la borraba poniendo la lista encima: el formulario aparecia
// y desaparecia solo. Esta bandera se levanta justo antes de llamar a go() y
// se consume en el primer ncrInit que llegue.
var _ncrSaltarInit = false;

function ncrInit(){
  if(_ncrSaltarInit){ _ncrSaltarInit=false; return; }
  if(!ncrPuedeVer()){
    var c=document.getElementById('ncr-content');
    if(c) c.innerHTML='<div class="card">Esta pantalla no est\u00e1 disponible para tu usuario.</div>';
    return;
  }
  ncrLista();
}

async function ncrLista(){
  var c=document.getElementById('ncr-content'); if(!c) return;
  c.innerHTML=loading();

  // Los motivos de SAP, la primera vez que se abre.
  try{ await ncrCargarMotivos(); }catch(e){}

  var f='select=*&order=creado_en.desc&limit=300';
  if(NCR_FILTRO.estado) f+='&estado=eq.'+NCR_FILTRO.estado;
  // Un vendedor solo ve las suyas. El RLS de la base manda de verdad; esto es
  // para que la pantalla no le muestre un vacio raro.
  //
  // PERO quien aprueba o manda a SAP tiene que verlas TODAS, aunque su rol
  // figure como vendedor. Es el caso de Joselyn: el portal la reconoce por
  // correo para pintarle los botones, pero este filtro le dejaba la lista
  // vacia, asi que tenia los botones y nada que aprobar.
  if(ncrRol()==='vendedor' && !ncrPuedeAprobar() && !ncrPuedeEnviarSap()){
    f+='&solicitado_por=eq.'+encodeURIComponent(ncrYo());
  }
  if(NCR_FILTRO.texto){
    var t=encodeURIComponent(NCR_FILTRO.texto);
    var n=parseInt(NCR_FILTRO.texto,10); if(!isFinite(n)) n=0;
    f+='&or=(cardname.ilike.*'+t+'*,cardcode.ilike.*'+t+'*,docnum.eq.'+n+',nota_num.ilike.*'+t+'*)';
  }

  var rows=[];
  try{ rows = await q('solicitudes_nota', f) || []; }
  catch(e){ rows=[]; }
  NCR_LISTA = rows;

  var pend=0, apr=0, mtot=0;
  rows.forEach(function(r){
    if(r.estado==='pendiente') pend++;
    if(r.estado==='aprobada'){ apr++; mtot+=ncrNum(r.monto); }
  });

  var h='';

  h+='<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;margin-bottom:14px">';
  if(ncrPuedeCrear()){
    h+='<button class="btn btn-p" onclick="ncrNueva()">+ Nueva nota</button>';
  }
  h+='<button class="btn btn-sm" onclick="ncrLista()">\u21bb Actualizar</button>';
  h+='</div>';

  h+='<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:14px">'
    +'<div class="kpi"><div class="kpi-lbl">Solicitudes</div><div class="kpi-val">'+rows.length+'</div></div>'
    +'<div class="kpi"><div class="kpi-lbl">Por aprobar</div><div class="kpi-val" style="color:'+(pend?'var(--amber,#d97706)':'inherit')+'">'+pend+'</div></div>'
    +'<div class="kpi"><div class="kpi-lbl">Aprobado</div><div class="kpi-val">'+ncrMon(mtot)+'</div></div>'
    +'</div>';

  h+='<div class="card" style="margin-bottom:14px"><div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center">';
  h+='<input id="ncr-q" class="inp" placeholder="Cliente, c\u00f3digo, # factura o # nota" value="'+ncrEsc(NCR_FILTRO.texto)+'" '
    +'style="flex:1;min-width:220px" onkeydown="if(event.key===\'Enter\')ncrFiltrar()">';
  h+='<select id="ncr-f-estado" class="inp" onchange="ncrFiltrar()" style="min-width:150px">';
  h+='<option value="">Todos los estados</option>';
  Object.keys(NCR_ESTADOS).forEach(function(k){
    h+='<option value="'+k+'"'+(NCR_FILTRO.estado===k?' selected':'')+'>'+NCR_ESTADOS[k].t+'</option>';
  });
  h+='</select>';
  h+='<button class="btn btn-sm" onclick="ncrFiltrar()">Buscar</button>';
  h+='<button class="btn btn-sm" onclick="ncrLimpiar()">Limpiar</button>';
  h+='</div></div>';

  h+='<div id="ncr-msg" style="display:none"></div>';

  if(!rows.length){
    h+=empty('A\u00fan no hay notas registradas');
  } else {
    h+='<div class="card"><div style="overflow-x:auto"><table class="tbl">';
    h+='<tr><th>#</th><th>Tipo</th><th>Fecha</th><th>Cliente</th><th>Factura</th>'
      +'<th>Motivo</th><th>Grupo</th><th style="text-align:right">Monto</th>'
      +'<th>Vendedor</th><th>Estado</th></tr>';
    rows.forEach(function(r){
      var es=NCR_ESTADOS[r.estado]||{t:r.estado,c:'b-gray'};
      h+='<tr>'
        +'<td><span style="color:var(--blue2);cursor:pointer;font-weight:700" onclick="ncrVer('+r.id+')"><u>'
          +(r.nota_num?ncrEsc(r.nota_num):('S-'+r.id))+'</u></span></td>'
        +'<td>'+(r.tipo==='debito'?'D\u00e9bito':'Cr\u00e9dito')+'</td>'
        +'<td>'+fmtD(r.creado_en)+'</td>'
        +'<td>'+ncrEsc(r.cardname||r.cardcode||'')+'</td>'
        +'<td>'+(r.docnum?('<span style="color:var(--blue2);cursor:pointer" onclick="verFactura('+r.docnum+')"><u>#'+r.docnum+'</u></span>'):'\u2014')+'</td>'
        +'<td style="font-size:12px">'+ncrEsc(r.motivo||'')+'</td>'
        +'<td style="font-size:12px;color:var(--text2)">'+ncrEsc(r.grupo||'\u2014')+'</td>'
        +'<td style="text-align:right;font-weight:700">'+ncrMon(r.monto)+'</td>'
        +'<td style="font-size:12px">'+ncrEsc(r.vendedor||'')+'</td>'
        +'<td><span class="badge '+es.c+'">'+es.t+'</span></td>'
        +'</tr>';
    });
    h+='</table></div></div>';
  }

  c.innerHTML=h;
}

function ncrFiltrar(){
  NCR_FILTRO.texto  = ((document.getElementById('ncr-q')||{}).value||'').trim();
  NCR_FILTRO.estado = ((document.getElementById('ncr-f-estado')||{}).value||'');
  ncrLista();
}
function ncrLimpiar(){ NCR_FILTRO={estado:'',texto:''}; ncrLista(); }


/* ══════════════════════════════════════════════════════════════════════════
   FORMULARIO
   ══════════════════════════════════════════════════════════════════════════ */

// Todo lo que el vendedor esta editando en este momento.
var NCR = null;

function ncrNuevoEstado(){
  return {
    // El por defecto es el PRIMERO que mande SAP, no un nombre fijo: si
    // alguien renombra el motivo en SAP, aqui no queda uno huerfano.
    id:null, tipo:'credito',
    motivo:(NCR_MOTIVOS_POR_LINEA[0] || NCR_MOTIVOS_CREDITO[0] || ''),
    base:'lineas',
    grupo:'', grupo_nombre:'', grupo_auto:true,
    cardcode:'', cardname:'', pais:'', slpcode:null, vendedor:'',
    docnum:null, fecha_factura:'', total_factura:0,
    monto:0, comentarios:'', nota_num:'',
    estado:'borrador', lineas:[], adjuntos:[], _facturaCargada:false
  };
}

// Se puede llamar con un numero de factura (desde el detalle de la factura) o
// sin nada (desde el menu, y entonces el vendedor la busca aqui).
function ncrNueva(docnum){
  if(!ncrPuedeCrear()){ alert('No tienes permiso para crear notas.'); return; }
  NCR = ncrNuevoEstado();
  _ncrSaltarInit = true;
  try{ go('notas', document.getElementById('nav-ncr')); }catch(e){}
  ncrRenderForm();
  if(docnum){
    var i=document.getElementById('ncr-docnum');
    if(i) i.value=docnum;
    ncrCargarFactura();
  }
}

// Trae la factura sin depender de que existan columnas concretas.
//
// `facturas` viene desnormalizada del sync: una fila por LINEA, y cada fila
// arrastra los datos de la cabecera (cardcode, cardname, doctotal...). Asi que
// con una sola consulta `select=*` se tiene todo, y de paso se evita el 400
// que daba PostgREST si alguna columna del select no existia en esta base.
//
// OJO: q() se traga los errores y devuelve [] (kennedy-1.js, linea ~261), asi
// que un fallo de permisos y una factura inexistente se veian igual. Por eso,
// cuando no hay resultados, se repregunta a pelo para poder decir que paso.
async function ncrTraerFactura(num){
  var filas = await q('facturas','select=*&docnum=eq.'+num+'&order=linenum');
  if(filas && filas.length) return {filas:filas, fuente:'facturas'};

  // Segundo intento: la vista que usa la pantalla de Facturas. No trae lineas,
  // pero al menos permite levantar la nota por monto.
  var v = await q('vista_facturas','select=*&docnum=eq.'+num+'&limit=1');
  if(v && v.length) return {filas:v, fuente:'vista_facturas', sinLineas:true};

  // Y por si el cliente es de NAPA.
  var na = await q('facturas_napa','select=*&docnum=eq.'+num+'&order=linenum');
  if(na && na.length) return {filas:na, fuente:'facturas_napa'};

  // Nada. Se mira si fue un error de verdad o si la factura no existe.
  var detalle='';
  try{
    var r=await fetch(SB+'/rest/v1/facturas?select=docnum&limit=1',
      {headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK()}});
    if(!r.ok){
      var t=await r.text();
      detalle='La base rechaz\u00f3 la consulta a <b>facturas</b> (HTTP '+r.status+'): '
        +ncrEsc(t.slice(0,200));
    }
  }catch(e){ detalle='No hubo respuesta de la base: '+ncrEsc(e.message||e); }
  return {filas:[], detalle:detalle};
}

async function ncrCargarFactura(){
  var inp=document.getElementById('ncr-docnum');
  var num=parseInt((inp&&inp.value)||'',10);
  if(!num){ ncrMsg('Escribe el n\u00famero de la factura.','err'); return; }

  ncrMsg('Buscando la factura #'+num+'\u2026');
  var res;
  try{ res = await ncrTraerFactura(num); }
  catch(e){ ncrMsg('No se pudo consultar la factura: '+ncrEsc(e.message||e),'err'); return; }

  if(!res.filas.length){
    ncrMsg(res.detalle
      ? ('No pude leer las facturas.<br>'+res.detalle)
      : ('No existe la factura #'+num+', o tu usuario no tiene permiso para verla.'),
      'err');
    return;
  }

  var head = res.filas[0];
  // En `vista_facturas` cada fila es una factura entera: no hay lineas.
  var lineas = res.sinLineas ? [] : res.filas.filter(function(f){ return f.itemcode; });

  NCR.docnum        = head.docnum;
  NCR.cardcode      = head.cardcode||'';
  NCR.cardname      = head.cardname||'';
  NCR.slpcode       = (head.slpcode!=null?head.slpcode:null);
  NCR.vendedor      = head.nombrevendedor||'';
  NCR.fecha_factura = String(head.docdate||'').slice(0,10);
  NCR.total_factura = ncrNum(head.doctotal);
  NCR._facturaCargada = true;

  // El pais no viene en la factura: sale de la ficha del cliente.
  if(NCR.cardcode){
    try{
      var cl=await q('clientes','select=country,nombrevendedor,slpcode&cardcode=eq.'+encodeURIComponent(NCR.cardcode)+'&limit=1');
      if(cl&&cl[0]){
        NCR.pais = cl[0].country||'';
        if(!NCR.vendedor) NCR.vendedor = cl[0].nombrevendedor||'';
        if(NCR.slpcode==null) NCR.slpcode = (cl[0].slpcode!=null?cl[0].slpcode:null);
      }
    }catch(e){}
  }

  // Grupo contable de cada articulo, para poder deducir el de la nota.
  var grupos={};
  var codes=lineas.map(function(l){return l.itemcode;}).filter(Boolean);
  if(codes.length){
    try{
      var enc=codes.map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
      var inv=await q('vista_inventario','select=itemcode,grupo,subg&itemcode=in.('+enc+')&limit=2000');
      (inv||[]).forEach(function(i){
        var etiqueta = i.grupo || (typeof subgLabel==='function' ? subgLabel(i.subg) : '');
        grupos[i.itemcode]=ncrGrupoDeTexto(etiqueta);
      });
    }catch(e){}
  }

  NCR.lineas = lineas.map(function(l){
    var neto=ncrPrecioNeto(l);
    return {
      linenum:        (l.linenum!=null?Number(l.linenum):null),
      itemcode:       l.itemcode||'',
      dscription:     l.dscription||'',
      cant_facturada: ncrNum(l.quantity),
      cant_afectada:  0,
      precio:         neto,
      monto:          0,
      condicion:      'NO LLEGO',
      nota:           '',
      grupo:          grupos[l.itemcode]||'4002-001',
      _sel:           false,
      _montoManual:   false
    };
  });

  if(!lineas.length){
    // Sin lineas no se puede repartir el monto por articulo. Se cambia a monto
    // directo para que el vendedor no se quede mirando una tabla vacia.
    NCR.base='monto';
    ncrMsg('Factura #'+num+' cargada, pero no pude leer sus l\u00edneas'
      +(res.fuente==='vista_facturas'?' (solo hay cabecera en <b>vista_facturas</b>)':'')
      +'. La nota queda por <b>monto directo</b>; escribe el importe a mano.','info');
  } else {
    ncrMsg('Factura #'+num+' cargada con '+lineas.length+' l\u00ednea(s). '
      +'Revisa los datos y corrige lo que haga falta.','ok');
  }
  ncrRenderForm();
}

function ncrEsPorLinea(motivo){ return NCR_MOTIVOS_POR_LINEA.indexOf(motivo)>=0; }

// Cambiar el tipo reescribe la lista de motivos, asi que hay que asegurarse de
// que el motivo elegido siga existiendo.
function ncrSetTipo(v){
  NCR.tipo=v;
  var lista=(v==='debito')?NCR_MOTIVOS_DEBITO:NCR_MOTIVOS_CREDITO;
  if(lista.indexOf(NCR.motivo)<0) NCR.motivo=lista[0];
  if(v==='debito') NCR.base='monto';       // una nota de debito nunca va por lineas
  ncrRenderForm();
}
function ncrSetMotivo(v){
  NCR.motivo=v;
  NCR.base = (NCR.tipo!=='debito' && ncrEsPorLinea(v)) ? 'lineas' : 'monto';
  ncrRenderForm();
}
function ncrSetBase(v){ NCR.base=v; ncrRenderForm(); }

// Recoge del DOM lo que el usuario escribio, para no perderlo al repintar.
function ncrLeerForm(){
  if(!NCR) return;
  function val(id){ var e=document.getElementById(id); return e?e.value:undefined; }
  var v;
  if((v=val('ncr-cardcode'))!==undefined) NCR.cardcode=v.trim();
  if((v=val('ncr-cardname'))!==undefined) NCR.cardname=v.trim();
  if((v=val('ncr-pais'))!==undefined)     NCR.pais=v.trim();
  if((v=val('ncr-vendedor'))!==undefined) NCR.vendedor=v.trim();
  if((v=val('ncr-fecha'))!==undefined)    NCR.fecha_factura=v;
  if((v=val('ncr-notanum'))!==undefined)  NCR.nota_num=v.trim();
  if((v=val('ncr-coment'))!==undefined)   NCR.comentarios=v;
  // Las descripciones de los adjuntos se leen de sus propios campos.
  (NCR.adjuntos||[]).forEach(function(a,i){
    var e=document.getElementById('ncr-adj-d'+i);
    if(e) a.descripcion=e.value;
  });
  if((v=val('ncr-grupo'))!==undefined && v!==''){ NCR.grupo=v; NCR.grupo_nombre=ncrGrupoNombre(v); }
  if(NCR.base==='monto'){ if((v=val('ncr-monto'))!==undefined) NCR.monto=ncrNum(v); }
}

// ── Lineas ──────────────────────────────────────────────────────────────────
function ncrLineaSel(i, chk){
  var l=NCR.lineas[i]; if(!l) return;
  l._sel=!!chk;
  // Al marcarla se asume que se pide la linea completa; el vendedor ajusta.
  if(l._sel && ncrNum(l.cant_afectada)<=0) l.cant_afectada=l.cant_facturada;
  if(!l._sel) l.cant_afectada=0;
  ncrRecalcLinea(i);
  ncrPintarLineas();
}
function ncrLineaCant(i, v){
  var l=NCR.lineas[i]; if(!l) return;
  var c=ncrNum(v);
  if(c<0) c=0;
  if(c>l.cant_facturada) c=l.cant_facturada;   // no se acredita mas de lo facturado
  l.cant_afectada=c;
  l._sel = c>0;
  l._montoManual=false;                        // vuelve a calcularse solo
  ncrRecalcLinea(i);
  ncrPintarLineas();
}
function ncrLineaPrecio(i, v){
  var l=NCR.lineas[i]; if(!l) return;
  l.precio=ncrNum(v); l._montoManual=false;
  ncrRecalcLinea(i); ncrPintarLineas();
}
function ncrLineaMonto(i, v){
  var l=NCR.lineas[i]; if(!l) return;
  l.monto=ncrNum(v); l._montoManual=true;      // el vendedor lo puso a mano
  ncrTotales(); ncrPintarTotales();
}
function ncrLineaCampo(i, campo, v){
  var l=NCR.lineas[i]; if(!l) return;
  l[campo]=v;
  if(campo==='grupo') ncrTotales();
}
function ncrRecalcLinea(i){
  var l=NCR.lineas[i]; if(!l) return;
  if(!l._montoManual) l.monto = Math.round(ncrNum(l.cant_afectada)*ncrNum(l.precio)*100)/100;
  ncrTotales();
}

// Suma las lineas y decide el grupo de la nota. Si todas las lineas marcadas
// caen en el mismo grupo, ese es el de la nota; si estan mezcladas se deja
// OTROS y se avisa, que es lo que hace contabilidad en el papel.
function ncrTotales(){
  if(NCR.base==='monto'){ return; }
  var tot=0, grupos={};
  NCR.lineas.forEach(function(l){
    if(!l._sel || ncrNum(l.cant_afectada)<=0) return;
    tot += ncrNum(l.monto);
    grupos[l.grupo||'4002-001']=1;
  });
  NCR.monto = Math.round(tot*100)/100;
  if(NCR.grupo_auto){
    var ks=Object.keys(grupos);
    NCR.grupo = (ks.length===1) ? ks[0] : (ks.length>1 ? '4002-001' : '');
    NCR.grupo_nombre = ncrGrupoNombre(NCR.grupo);
    NCR._grupoMezclado = ks.length>1;
  }
}

function ncrGrupoAuto(chk){
  NCR.grupo_auto=!!chk;
  if(NCR.grupo_auto) ncrTotales();
  ncrRenderForm();
}

function ncrMarcarTodas(chk){
  NCR.lineas.forEach(function(l,i){
    l._sel=!!chk;
    l.cant_afectada = chk ? l.cant_facturada : 0;
    l._montoManual=false;
    ncrRecalcLinea(i);
  });
  ncrPintarLineas();
}


/* ── Pintado ──────────────────────────────────────────────────────────────── */

function ncrRenderForm(){
  var c=document.getElementById('ncr-content'); if(!c||!NCR) return;
  var motivos=(NCR.tipo==='debito')?NCR_MOTIVOS_DEBITO:NCR_MOTIVOS_CREDITO;
  var inp='width:100%;padding:8px 10px;border:1px solid var(--border);border-radius:var(--r2);'
    +'background:var(--surface);color:var(--text);font-family:inherit;font-size:13px';
  var lab='display:block;font-size:11px;color:var(--text3);text-transform:uppercase;'
    +'letter-spacing:.04em;font-weight:600;margin-bottom:4px';

  var h='';

  h+='<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;margin-bottom:14px">';
  h+='<button class="btn btn-sm" onclick="ncrLista()">\u2190 Volver a la lista</button>';
  if(NCR.id){
    h+='<button class="btn btn-sm" onclick="ncrPdf('+NCR.id+')">\ud83d\udda8\ufe0f Imprimir</button>';
    h+='<button class="btn btn-sm" onclick="ncrDescargar('+NCR.id+')" style="background:var(--green);color:#fff;border-color:var(--green)">\u2b07 Descargar PDF</button>';
  }
  h+='</div>';

  h+='<div id="ncr-msg" style="display:none"></div>';

  // ── 1. La factura ─────────────────────────────────────────────────────────
  h+='<div class="card" style="margin-bottom:14px">';
  h+='<div class="ct" style="margin-bottom:10px">1 \u00b7 Factura de origen</div>';
  h+='<div style="display:flex;gap:8px;align-items:flex-end;flex-wrap:wrap">';
  h+='<div style="flex:0 0 200px"><label style="'+lab+'">N\u00famero de factura</label>'
    +'<input id="ncr-docnum" style="'+inp+'" placeholder="Ej. 108234" value="'+(NCR.docnum||'')+'" '
    +'onkeydown="if(event.key===\'Enter\'){event.preventDefault();ncrCargarFactura();}"></div>';
  h+='<button class="btn btn-p" onclick="ncrCargarFactura()">Buscar factura</button>';
  if(NCR.docnum && NCR._facturaCargada){
    h+='<div style="margin-left:auto;font-size:12px;color:var(--text2);text-align:right">'
      +'Total facturado <b style="font-size:15px;color:var(--text)">'+ncrMon(NCR.total_factura)+'</b><br>'
      +'<span style="color:var(--text3)">'+fmtD(NCR.fecha_factura)+'</span></div>';
  }
  h+='</div>';
  h+='<div style="font-size:12px;color:var(--text3);margin-top:8px">'
    +'Al cargarla se rellenan el cliente, el pa\u00eds, el vendedor y las l\u00edneas. '
    +'Todo queda editable.</div>';
  h+='</div>';

  // ── 2. Generales del documento ────────────────────────────────────────────
  h+='<div class="card" style="margin-bottom:14px">';
  h+='<div class="ct" style="margin-bottom:10px">2 \u00b7 Generales del documento</div>';
  h+='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(190px,1fr));gap:12px">';
  h+='<div><label style="'+lab+'">C\u00f3digo del cliente</label><input id="ncr-cardcode" style="'+inp+'" value="'+ncrEsc(NCR.cardcode)+'"></div>';
  h+='<div style="grid-column:span 2"><label style="'+lab+'">Nombre</label><input id="ncr-cardname" style="'+inp+'" value="'+ncrEsc(NCR.cardname)+'"></div>';
  h+='<div><label style="'+lab+'">Pa\u00eds</label><input id="ncr-pais" style="'+inp+'" value="'+ncrEsc(NCR.pais)+'"></div>';
  h+='<div><label style="'+lab+'">Vendedor</label><input id="ncr-vendedor" style="'+inp+'" value="'+ncrEsc(NCR.vendedor)+'"></div>';
  h+='<div><label style="'+lab+'">Fecha de la factura</label><input id="ncr-fecha" type="date" style="'+inp+'" value="'+ncrEsc(NCR.fecha_factura)+'"></div>';
  h+='<div><label style="'+lab+'">N\u00famero de nota <span style="text-transform:none;font-weight:400">(interno, opcional)</span></label>'
    +'<input id="ncr-notanum" style="'+inp+'" value="'+ncrEsc(NCR.nota_num)+'" placeholder="\u2014"></div>';
  h+='</div></div>';

  // ── 3. Tipo y motivo ──────────────────────────────────────────────────────
  h+='<div class="card" style="margin-bottom:14px">';
  h+='<div class="ct" style="margin-bottom:10px">3 \u00b7 Tipo de nota y motivo</div>';

  h+='<div style="display:flex;gap:10px;margin-bottom:14px;flex-wrap:wrap">';
  [['credito','Nota de cr\u00e9dito'],['debito','Nota de d\u00e9bito']].forEach(function(t){
    var on=(NCR.tipo===t[0]);
    h+='<label style="flex:1;min-width:180px;cursor:pointer;border:2px solid '+(on?'var(--blue)':'var(--border)')
      +';border-radius:var(--r2);padding:11px 14px;background:'+(on?'rgba(79,140,255,.08)':'var(--surface)')
      +';display:flex;align-items:center;gap:9px;font-weight:600">'
      +'<input type="radio" name="ncr-tipo" '+(on?'checked':'')+' onchange="ncrLeerForm();ncrSetTipo(\''+t[0]+'\')">'
      +t[1]+'</label>';
  });
  h+='</div>';

  h+='<label style="'+lab+'">Motivo</label>';
  h+='<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(215px,1fr));gap:7px">';
  motivos.forEach(function(m){
    var on=(NCR.motivo===m);
    h+='<label style="cursor:pointer;border:1px solid '+(on?'var(--blue)':'var(--border)')
      +';border-radius:var(--r2);padding:8px 11px;font-size:12.5px;background:'+(on?'rgba(79,140,255,.08)':'var(--surface)')
      +';display:flex;align-items:center;gap:8px">'
      +'<input type="radio" name="ncr-motivo" '+(on?'checked':'')+' onchange="ncrLeerForm();ncrSetMotivo(\''+m.replace(/'/g,"\\'")+'\')">'
      +'<span>'+m+'</span></label>';
  });
  h+='</div>';

  // Como se calcula el monto
  if(NCR.tipo!=='debito'){
    h+='<div style="margin-top:14px;display:flex;gap:10px;flex-wrap:wrap;align-items:center">';
    h+='<span style="'+lab+';margin:0">C\u00e1lculo del monto</span>';
    [['lineas','Por l\u00edneas de la factura'],['monto','Por monto directo']].forEach(function(b){
      var on=(NCR.base===b[0]);
      h+='<label style="cursor:pointer;border:1px solid '+(on?'var(--blue)':'var(--border)')
        +';border-radius:14px;padding:5px 13px;font-size:12.5px;background:'+(on?'rgba(79,140,255,.08)':'var(--surface)')+'">'
        +'<input type="radio" name="ncr-base" '+(on?'checked':'')+' onchange="ncrLeerForm();ncrSetBase(\''+b[0]+'\')" style="margin-right:6px">'
        +b[1]+'</label>';
    });
    h+='</div>';
  }
  h+='</div>';

  // ── 4. Lineas o monto ─────────────────────────────────────────────────────
  if(NCR.base==='lineas'){
    h+='<div class="card" style="margin-bottom:14px">';
    h+='<div class="ch" style="margin-bottom:10px">'
      +'<span class="ct">4 \u00b7 L\u00edneas afectadas</span>'
      +'<label style="font-size:12px;color:var(--text2);cursor:pointer;display:flex;align-items:center;gap:6px">'
      +'<input type="checkbox" onchange="ncrMarcarTodas(this.checked)"> Marcar todas</label></div>';
    h+='<div id="ncr-lineas"></div>';
    h+='</div>';
  } else {
    h+='<div class="card" style="margin-bottom:14px">';
    h+='<div class="ct" style="margin-bottom:10px">4 \u00b7 Monto</div>';
    h+='<div style="display:flex;gap:12px;align-items:flex-end;flex-wrap:wrap">';
    h+='<div style="flex:0 0 220px"><label style="'+lab+'">Monto de la nota (US$)</label>'
      +'<input id="ncr-monto" type="number" step="0.01" min="0" style="'+inp+';font-size:17px;font-weight:700" '
      +'value="'+(NCR.monto?ncrNum(NCR.monto).toFixed(2):'')+'" oninput="NCR.monto=ncrNum(this.value);ncrPintarTotales()"></div>';
    if(NCR.total_factura>0){
      h+='<div style="font-size:12px;color:var(--text3)">Total de la factura: '+ncrMon(NCR.total_factura)+'</div>';
    }
    h+='</div></div>';
  }

  // ── 5. Grupo a aplicar ────────────────────────────────────────────────────
  h+='<div class="card" style="margin-bottom:14px">';
  h+='<div class="ct" style="margin-bottom:8px">5 \u00b7 Grupo a aplicar</div>';
  if(NCR.base==='lineas'){
    h+='<div style="font-size:12px;color:var(--text3);margin-bottom:10px">'
      +'En las notas por inventario el sistema escoge el grupo a partir de los art\u00edculos. '
      +'Si necesitas otro, destilda la casilla y elige a mano.</div>';
    h+='<label style="display:flex;align-items:center;gap:8px;font-size:13px;margin-bottom:10px;cursor:pointer">'
      +'<input type="checkbox" '+(NCR.grupo_auto?'checked':'')+' onchange="ncrLeerForm();ncrGrupoAuto(this.checked)"> '
      +'Dejar que el sistema lo escoja</label>';
    if(NCR._grupoMezclado && NCR.grupo_auto){
      h+='<div style="font-size:12px;color:var(--amber,#d97706);margin-bottom:10px">'
        +'\u26a0 Las l\u00edneas marcadas son de grupos distintos. Se us\u00f3 <b>OTROS</b>; '
        +'si contabilidad necesita separarlas, haz una nota por grupo.</div>';
    }
  }
  h+='<select id="ncr-grupo" style="'+inp+';max-width:340px" '+((NCR.base==='lineas'&&NCR.grupo_auto)?'disabled':'')
    +' onchange="NCR.grupo=this.value;NCR.grupo_nombre=ncrGrupoNombre(this.value)">';
  h+='<option value="">\u2014 Elegir grupo \u2014</option>';
  NCR_GRUPOS.forEach(function(g){
    h+='<option value="'+g.v+'"'+(NCR.grupo===g.v?' selected':'')+'>'+g.v+' \u00b7 '+g.t+'</option>';
  });
  h+='</select>';
  h+='</div>';

  // ── 6. Comentarios ────────────────────────────────────────────────────────
  h+='<div class="card" style="margin-bottom:14px">';
  h+='<div class="ct" style="margin-bottom:8px">6 \u00b7 Comentarios</div>';
  h+='<textarea id="ncr-coment" rows="3" style="'+inp+';resize:vertical" '
    +'placeholder="Detalle de lo ocurrido: qui\u00e9n report\u00f3, cu\u00e1ndo, n\u00famero de gu\u00eda, etc.">'
    +ncrEsc(NCR.comentarios)+'</textarea>';
  h+='</div>';

  // ── 7. Adjuntos ───────────────────────────────────────────────────────────
  h+='<div class="card" style="margin-bottom:14px">';
  h+='<div class="ct" style="margin-bottom:8px">7 \u00b7 Adjuntos del reclamo</div>';
  h+='<div style="font-size:12px;color:var(--text3);margin-bottom:10px">'
    +'Fotos de la mercanc\u00eda, la gu\u00eda de transporte, el correo del cliente. '
    +'Quedan guardados con la nota y los ve quien la aprueba.</div>';
  // Dos entradas: la de camara abre directamente el carrete/camara en el iPad.
  h+='<input type="file" id="ncr-adj-file" multiple accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.eml,.msg" '
    +'style="display:none" onchange="ncrAdjSubir(this)">';
  h+='<input type="file" id="ncr-adj-cam" accept="image/*" capture="environment" '
    +'style="display:none" onchange="ncrAdjSubir(this)">';
  h+='<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:12px">'
    +'<button class="btn btn-sm" onclick="document.getElementById(\'ncr-adj-file\').click()">'
    +'\ud83d\udcce Adjuntar archivos</button>'
    +'<button class="btn btn-sm" onclick="document.getElementById(\'ncr-adj-cam\').click()">'
    +'\ud83d\udcf7 Tomar foto</button>'
    +'</div>';
  h+='<div id="ncr-adj-lista"></div>';
  h+='</div>';

  // ── Totales y acciones ────────────────────────────────────────────────────
  h+='<div class="card" style="position:sticky;bottom:0;z-index:5">';
  h+='<div id="ncr-totales" style="margin-bottom:12px"></div>';
  h+='<div style="display:flex;gap:8px;flex-wrap:wrap">';
  h+='<button class="btn" onclick="ncrGuardar(\'borrador\')">Guardar borrador</button>';
  h+='<button class="btn btn-p" onclick="ncrGuardar(\'pendiente\')">Enviar a aprobaci\u00f3n</button>';
  h+='<button class="btn btn-sm" onclick="ncrLista()" style="margin-left:auto">Cancelar</button>';
  h+='</div></div>';

  c.innerHTML=h;
  if(NCR.base==='lineas') ncrPintarLineas(); else ncrPintarTotales();
  ncrPintarAdjuntos();
}

function ncrPintarLineas(){
  var box=document.getElementById('ncr-lineas'); if(!box) return;
  if(!NCR.lineas.length){
    box.innerHTML=empty('Carga primero una factura para ver sus l\u00edneas');
    ncrPintarTotales(); return;
  }
  var ci='width:100%;padding:5px 7px;border:1px solid var(--border);border-radius:6px;'
    +'background:var(--surface);color:var(--text);font-family:inherit;font-size:12.5px';

  var h='<div style="overflow-x:auto"><table class="tbl">';
  h+='<tr><th style="width:34px"></th><th>SKU</th><th>Descripci\u00f3n</th>'
    +'<th style="text-align:right">Facturado</th><th style="text-align:right;width:96px">Afectado</th>'
    +'<th style="text-align:right;width:104px">Precio unit.</th>'
    +'<th style="text-align:right;width:112px">Monto</th>'
    +'<th style="width:170px">Condici\u00f3n</th><th style="width:150px">Grupo</th><th style="width:180px">Nota</th></tr>';

  NCR.lineas.forEach(function(l,i){
    var on=l._sel && ncrNum(l.cant_afectada)>0;
    h+='<tr style="'+(on?'background:rgba(79,140,255,.06)':'')+'">';
    h+='<td><input type="checkbox" '+(l._sel?'checked':'')+' onchange="ncrLineaSel('+i+',this.checked)"></td>';
    h+='<td style="font-family:monospace;font-size:12px">'+ncrEsc(l.itemcode)+'</td>';
    h+='<td style="font-size:12.5px">'+ncrEsc(l.dscription)+'</td>';
    h+='<td style="text-align:right">'+ncrNum(l.cant_facturada).toLocaleString('en-US')+'</td>';
    h+='<td><input type="number" step="1" min="0" max="'+l.cant_facturada+'" style="'+ci+';text-align:right" '
      +'value="'+(l.cant_afectada||'')+'" onchange="ncrLineaCant('+i+',this.value)"></td>';
    h+='<td><input type="number" step="0.01" min="0" style="'+ci+';text-align:right" '
      +'value="'+ncrNum(l.precio).toFixed(2)+'" onchange="ncrLineaPrecio('+i+',this.value)"></td>';
    h+='<td><input type="number" step="0.01" min="0" style="'+ci+';text-align:right;font-weight:700'
      +(l._montoManual?';border-color:var(--amber,#d97706)':'')+'" '
      +'value="'+ncrNum(l.monto).toFixed(2)+'" onchange="ncrLineaMonto('+i+',this.value)" '
      +'title="Se calcula solo. Si lo escribes a mano se respeta tu valor.">'+'</td>';
    h+='<td><select style="'+ci+'" onchange="ncrLineaCampo('+i+',\'condicion\',this.value)">';
    NCR_CONDICIONES.forEach(function(cd){
      h+='<option value="'+cd+'"'+(l.condicion===cd?' selected':'')+'>'+cd+'</option>';
    });
    h+='</select></td>';
    h+='<td><select style="'+ci+'" onchange="ncrLineaCampo('+i+',\'grupo\',this.value);ncrPintarTotales()">';
    NCR_GRUPOS.forEach(function(g){
      h+='<option value="'+g.v+'"'+(l.grupo===g.v?' selected':'')+'>'+g.t.replace('GRUPO DE ','')+'</option>';
    });
    h+='</select></td>';
    h+='<td><input style="'+ci+'" value="'+ncrEsc(l.nota)+'" placeholder="Opcional" '
      +'onchange="ncrLineaCampo('+i+',\'nota\',this.value)"></td>';
    h+='</tr>';
  });
  h+='</table></div>';
  box.innerHTML=h;
  ncrPintarTotales();
}

function ncrPintarTotales(){
  var box=document.getElementById('ncr-totales'); if(!box) return;
  ncrTotales();
  var nsel=NCR.lineas.filter(function(l){ return l._sel && ncrNum(l.cant_afectada)>0; }).length;
  var pzas=0; NCR.lineas.forEach(function(l){ if(l._sel) pzas+=ncrNum(l.cant_afectada); });
  var pct = NCR.total_factura>0 ? (ncrNum(NCR.monto)/NCR.total_factura*100) : 0;

  var h='<div style="display:flex;gap:18px;align-items:baseline;flex-wrap:wrap">';
  h+='<div><div style="font-size:11px;color:var(--text3);text-transform:uppercase;letter-spacing:.04em;font-weight:600">'
    +'Monto de la nota</div><div style="font-size:26px;font-weight:800;color:var(--blue)">'+ncrMon(NCR.monto)+'</div></div>';
  if(NCR.base==='lineas'){
    h+='<div style="font-size:12.5px;color:var(--text2)">'+nsel+' l\u00ednea(s) \u00b7 '
      +ncrNum(pzas).toLocaleString('en-US')+' pzas</div>';
  }
  if(NCR.total_factura>0){
    h+='<div style="font-size:12.5px;color:'+(pct>100?'var(--red)':'var(--text2)')+'">'
      +pct.toFixed(1)+'% de la factura'+(pct>100?' \u2014 \u26a0 mayor que el total facturado':'')+'</div>';
  }
  if(NCR.grupo){
    h+='<div style="margin-left:auto;font-size:12.5px;color:var(--text2)">Grupo: <b>'
      +ncrEsc(NCR.grupo)+'</b> \u00b7 '+ncrEsc(ncrGrupoNombre(NCR.grupo))+'</div>';
  }
  h+='</div>';
  box.innerHTML=h;
}


/* ══════════════════════════════════════════════════════════════════════════
   ADJUNTOS
   ---------------------------------------------------------------------------
   Mismo patron que los adjuntos del chat: se sube al bucket con x-upsert y se
   guarda la URL publica. La subida es inmediata, sin esperar a que la nota se
   guarde, porque el vendedor suele adjuntar mientras llena el formulario y en
   el iPad perder el archivo por un toque en falso es muy facil.
   ══════════════════════════════════════════════════════════════════════════ */

var NCR_ADJ_BUCKET = 'notas-adjuntos';
var NCR_ADJ_MAX    = 25 * 1024 * 1024;   // 25 MB, igual que el chat

function ncrEsImagen(mime, nombre){
  if(/^image\//.test(String(mime||''))) return true;
  return /\.(jpe?g|png|gif|webp|heic|heif|bmp)$/i.test(String(nombre||''));
}
function ncrTam(b){
  b=ncrNum(b);
  if(b<1024) return b+' B';
  if(b<1024*1024) return (b/1024).toFixed(0)+' KB';
  return (b/1024/1024).toFixed(1)+' MB';
}

// Sube un archivo y devuelve el metadato ya listo para la tabla.
async function ncrAdjSubirUno(f){
  var limpio = String(f.name||'archivo').replace(/[^A-Za-z0-9._-]/g,'_').slice(-60);
  // La ruta empieza por el usuario: asi la politica de borrado de Storage
  // puede comprobar quien lo subio con storage.foldername(name).
  var ruta = ncrYo()+'/'+Date.now()+'-'+Math.random().toString(36).slice(2,10)+'-'+limpio;
  var r = await fetch(SB+'/storage/v1/object/'+NCR_ADJ_BUCKET+'/'+encodeURI(ruta), {
    method:'POST',
    headers:{'apikey':KEY, 'Authorization':'Bearer '+AUTHTOK(),
             'Content-Type': f.type || 'application/octet-stream', 'x-upsert':'true'},
    body: f
  });
  if(!r.ok) throw new Error((await r.text()).slice(0,180) || ('HTTP '+r.status));
  return {
    nombre: f.name || limpio,
    mime:   f.type || '',
    tamano: f.size || 0,
    ruta:   ruta,
    url:    SB+'/storage/v1/object/public/'+NCR_ADJ_BUCKET+'/'+encodeURI(ruta),
    descripcion: '',
    subido_por: ncrYo()
  };
}

async function ncrAdjSubir(el){
  var files = el && el.files ? [].slice.call(el.files) : [];
  if(el) el.value='';                       // permite volver a elegir el mismo
  if(!files.length) return;
  if(!NCR) return;

  if(!navigator.onLine){
    ncrMsg('Sin conexi\u00f3n: los adjuntos necesitan red para subirse.','err');
    return;
  }

  ncrLeerForm();                            // no perder lo escrito al repintar
  NCR.adjuntos = NCR.adjuntos || [];

  var ok=0, fallos=[];
  for(var i=0;i<files.length;i++){
    var f=files[i];
    if(f.size > NCR_ADJ_MAX){
      fallos.push(f.name+' pasa de 25 MB');
      continue;
    }
    // Se pinta un marcador de "subiendo" para que en archivos grandes el
    // vendedor vea que algo esta pasando.
    var marcador={nombre:f.name, mime:f.type, tamano:f.size, _subiendo:true};
    NCR.adjuntos.push(marcador);
    ncrPintarAdjuntos();
    try{
      var meta=await ncrAdjSubirUno(f);
      var idx=NCR.adjuntos.indexOf(marcador);
      if(idx>=0) NCR.adjuntos[idx]=meta; else NCR.adjuntos.push(meta);
      ok++;
    }catch(e){
      var j=NCR.adjuntos.indexOf(marcador);
      if(j>=0) NCR.adjuntos.splice(j,1);
      fallos.push(f.name+': '+(e.message||e));
    }
    ncrPintarAdjuntos();
  }

  if(fallos.length){
    ncrMsg('<b>No se pudieron subir '+fallos.length+' archivo(s):</b>'
      +'<ul style="margin:6px 0 0 18px">'
      +fallos.map(function(x){return '<li>'+ncrEsc(x)+'</li>';}).join('')+'</ul>','err');
  } else if(ok){
    ncrMsg('\u2713 '+ok+' archivo(s) adjuntado(s).','ok');
  }
}

// Se quita de la lista. El archivo se borra del bucket solo si la nota aun no
// se ha guardado con el; si ya estaba guardado, se borra al guardar de nuevo.
async function ncrAdjQuitar(i){
  if(!NCR || !NCR.adjuntos) return;
  var a=NCR.adjuntos[i]; if(!a) return;
  if(!confirm('\u00bfQuitar "'+(a.nombre||'este archivo')+'" de la nota?')) return;
  ncrLeerForm();
  NCR.adjuntos.splice(i,1);
  ncrPintarAdjuntos();
  if(a.ruta){
    try{
      await fetch(SB+'/storage/v1/object/'+NCR_ADJ_BUCKET+'/'+encodeURI(a.ruta),
        {method:'DELETE', headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK()}});
    }catch(e){}   // si falla queda huerfano en el bucket; no vale bloquear por eso
  }
}

function ncrPintarAdjuntos(){
  var box=document.getElementById('ncr-adj-lista'); if(!box) return;
  var arr=(NCR&&NCR.adjuntos)||[];
  if(!arr.length){
    box.innerHTML='<div style="border:1px dashed var(--border);border-radius:var(--r2);'
      +'padding:18px;text-align:center;color:var(--text3);font-size:12.5px">'
      +'Sin adjuntos todav\u00eda</div>';
    return;
  }
  var inp='width:100%;padding:5px 8px;border:1px solid var(--border);border-radius:6px;'
    +'background:var(--surface);color:var(--text);font-family:inherit;font-size:12px';

  var h='<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(210px,1fr));gap:10px">';
  arr.forEach(function(a,i){
    h+='<div style="border:1px solid var(--border);border-radius:var(--r2);overflow:hidden;'
      +'background:var(--surface2)">';
    if(a._subiendo){
      h+='<div style="height:104px;display:flex;align-items:center;justify-content:center;'
        +'color:var(--text3);font-size:12px">Subiendo\u2026</div>';
    } else if(ncrEsImagen(a.mime,a.nombre)){
      h+='<a href="'+ncrEsc(a.url)+'" target="_blank" rel="noopener">'
        +'<img src="'+ncrEsc(a.url)+'" style="width:100%;height:104px;object-fit:cover;display:block">'
        +'</a>';
    } else {
      h+='<a href="'+ncrEsc(a.url)+'" target="_blank" rel="noopener" '
        +'style="height:104px;display:flex;align-items:center;justify-content:center;'
        +'text-decoration:none;font-size:32px">\ud83d\udcc4</a>';
    }
    h+='<div style="padding:7px 9px">';
    h+='<div style="font-size:11.5px;font-weight:600;white-space:nowrap;overflow:hidden;'
      +'text-overflow:ellipsis" title="'+ncrEsc(a.nombre)+'">'+ncrEsc(a.nombre)+'</div>';
    h+='<div style="font-size:10.5px;color:var(--text3);margin-bottom:6px">'+ncrTam(a.tamano)+'</div>';
    if(!a._subiendo){
      h+='<input id="ncr-adj-d'+i+'" style="'+inp+'" placeholder="Qu\u00e9 es (opcional)" '
        +'value="'+ncrEsc(a.descripcion||'')+'">';
      h+='<div style="display:flex;gap:6px;margin-top:6px">'
        +'<a class="btn btn-sm" href="'+ncrEsc(a.url)+'" target="_blank" rel="noopener" '
        +'style="flex:1;text-align:center;text-decoration:none;font-size:11px">Ver</a>'
        +'<button class="btn btn-sm" onclick="ncrAdjQuitar('+i+')" '
        +'style="color:var(--red);border-color:var(--red);font-size:11px">Quitar</button>'
        +'</div>';
    }
    h+='</div></div>';
  });
  h+='</div>';
  box.innerHTML=h;
}


/* ══════════════════════════════════════════════════════════════════════════
   GUARDAR
   ══════════════════════════════════════════════════════════════════════════ */

function ncrValidar(){
  var e=[];
  if(!NCR.cardcode) e.push('Falta el c\u00f3digo del cliente.');
  if(!NCR.motivo)   e.push('Falta el motivo.');
  if(ncrNum(NCR.monto)<=0) e.push('El monto tiene que ser mayor que cero.');
  if(!NCR.grupo)    e.push('Falta el grupo a aplicar.');
  if(NCR.base==='lineas'){
    var n=NCR.lineas.filter(function(l){ return l._sel && ncrNum(l.cant_afectada)>0; }).length;
    if(!n) e.push('Marca al menos una l\u00ednea de la factura.');
  }
  if(NCR.total_factura>0 && ncrNum(NCR.monto)>NCR.total_factura+0.01){
    e.push('El monto supera el total de la factura ('+ncrMon(NCR.total_factura)+').');
  }
  return e;
}

async function ncrGuardar(estado){
  if(!NCR) return;
  ncrLeerForm();

  if(estado==='pendiente'){
    var errs=ncrValidar();
    if(errs.length){
      ncrMsg('<b>Revisa esto antes de enviar:</b><ul style="margin:6px 0 0 18px">'
        +errs.map(function(x){return '<li>'+ncrEsc(x)+'</li>';}).join('')+'</ul>','err');
      return;
    }
  }
  if(!navigator.onLine){
    ncrMsg('Sin conexi\u00f3n. Las notas necesitan red para guardarse; vuelve a intentarlo al reconectar.','err');
    return;
  }

  var cab={
    tipo: NCR.tipo, motivo: NCR.motivo, base: NCR.base,
    grupo: NCR.grupo||null, grupo_nombre: ncrGrupoNombre(NCR.grupo)||null,
    grupo_auto: !!NCR.grupo_auto,
    cardcode: NCR.cardcode, cardname: NCR.cardname||null, pais: NCR.pais||null,
    slpcode: NCR.slpcode, vendedor: NCR.vendedor||null,
    docnum: NCR.docnum||null,
    fecha_factura: NCR.fecha_factura||null,
    total_factura: NCR.total_factura||0,
    monto: ncrNum(NCR.monto),
    comentarios: NCR.comentarios||null,
    nota_num: NCR.nota_num||null,
    estado: estado
  };
  if(estado==='pendiente'){
    cab.solicitado_por = ncrYo();
    cab.solicitado_en  = new Date().toISOString();
  } else if(!NCR.id){
    cab.solicitado_por = ncrYo();
  }

  ncrMsg('Guardando\u2026');
  try{
    var id=NCR.id;
    if(id){
      await ncrEscribir('PATCH','solicitudes_nota?id=eq.'+id, cab);
      await ncrEscribir('DELETE','solicitudes_nota_lineas?nota_id=eq.'+id, null);
    } else {
      var creado=await ncrEscribir('POST','solicitudes_nota', cab);
      id=(creado&&creado[0]&&creado[0].id)||null;
      if(!id) throw new Error('La base no devolvi\u00f3 el id de la nota.');
      NCR.id=id;
    }

    if(NCR.base==='lineas'){
      var filas=NCR.lineas
        .filter(function(l){ return l._sel && ncrNum(l.cant_afectada)>0; })
        .map(function(l){
          return {
            nota_id:id, linenum:l.linenum, itemcode:l.itemcode, dscription:l.dscription,
            cant_facturada:ncrNum(l.cant_facturada), cant_afectada:ncrNum(l.cant_afectada),
            precio:ncrNum(l.precio), monto:ncrNum(l.monto),
            condicion:l.condicion||null, nota:l.nota||null, grupo:l.grupo||null
          };
        });
      if(filas.length) await ncrEscribir('POST','solicitudes_nota_lineas', filas);
    }

    // Adjuntos: se reescriben igual que las lineas. Los archivos ya estan en
    // el bucket; aqui solo va el metadato.
    await ncrEscribir('DELETE','solicitudes_nota_adjuntos?nota_id=eq.'+id, null);
    var adj=(NCR.adjuntos||[]).filter(function(a){ return a.url && !a._subiendo; })
      .map(function(a){
        return {nota_id:id, nombre:a.nombre||'archivo', mime:a.mime||null,
                tamano:ncrNum(a.tamano), ruta:a.ruta, url:a.url,
                descripcion:a.descripcion||null, subido_por:a.subido_por||ncrYo()};
      });
    if(adj.length) await ncrEscribir('POST','solicitudes_nota_adjuntos', adj);

    if(estado==='pendiente'){
      ncrMsg('\u2713 Solicitud enviada. Queda pendiente de aprobaci\u00f3n.','ok');
      setTimeout(function(){ ncrVer(id); }, 900);
    } else {
      ncrMsg('\u2713 Borrador guardado (S-'+id+'). Puedes seguir edit\u00e1ndolo.','ok');
    }
  }catch(e){
    ncrMsg('No se pudo guardar: '+ncrEsc(e.message||e),'err');
  }
}


/* ══════════════════════════════════════════════════════════════════════════
   DETALLE / APROBACION
   ══════════════════════════════════════════════════════════════════════════ */

async function ncrVer(id){
  var c=document.getElementById('ncr-content'); if(!c) return;
  _ncrSaltarInit = true;
  try{ go('notas', document.getElementById('nav-ncr')); }catch(e){}
  c.innerHTML=loading();

  var n, lin, adj;
  try{
    var r=await Promise.all([
      q('solicitudes_nota','select=*&id=eq.'+id+'&limit=1'),
      q('solicitudes_nota_lineas','select=*&nota_id=eq.'+id+'&order=linenum'),
      q('solicitudes_nota_adjuntos','select=*&nota_id=eq.'+id+'&order=id')
    ]);
    n=(r[0]&&r[0][0])||null; lin=r[1]||[]; adj=r[2]||[];
  }catch(e){ c.innerHTML='<div class="card">No se pudo cargar la nota.</div>'; return; }
  if(!n){ c.innerHTML='<div class="card">No encontr\u00e9 esa nota.</div>'; return; }

  var es=NCR_ESTADOS[n.estado]||{t:n.estado,c:'b-gray'};
  var mio=(String(n.solicitado_por||'')===ncrYo());
  var h='';

  h+='<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;margin-bottom:14px">';
  h+='<button class="btn btn-sm" onclick="ncrLista()">\u2190 Volver</button>';
  h+='<button class="btn btn-sm" onclick="ncrPdf('+n.id+')">\ud83d\udda8\ufe0f Imprimir</button>';
  h+='<button class="btn btn-sm" onclick="ncrDescargar('+n.id+')" style="background:var(--green);color:#fff;border-color:var(--green)">\u2b07 Descargar PDF</button>';
  if(n.estado==='borrador' && (mio||ncrPuedeAprobar()))
    h+='<button class="btn btn-sm btn-p" onclick="ncrEditar('+n.id+')">\u270e Editar</button>';
  if(n.docnum)
    h+='<button class="btn btn-sm" onclick="verFactura('+n.docnum+')">Ver factura #'+n.docnum+'</button>';
  // Reenviar: el correo puede fallar, o contabilidad puede pedirlo otra vez.
  // Sin esto habria que rechazar y volver a aprobar solo para que salga.
  if(n.estado==='aprobada' && ncrPuedeAprobar()){
    h+='<button class="btn btn-sm" onclick="ncrReenviar('+n.id+')" '
      +'title="Vuelve a mandar el PDF a contabilidad">\u2709 Reenviar a contabilidad</button>';
  }
  if(ncrPuedeBorrar()){
    h+='<button class="btn btn-sm" onclick="ncrBorrar('+n.id+')" style="margin-left:auto;'
      +'color:var(--red);border-color:var(--red)" title="Elimina la nota y sus adjuntos">'
      +'\ud83d\uddd1 Eliminar</button>';
  }
  h+='</div>';

  h+='<div id="ncr-msg" style="display:none"></div>';

  h+='<div style="background:var(--blue);color:#fff;border-radius:var(--r);padding:16px 20px;margin-bottom:14px">'
    +'<h2 style="font-size:18px;font-weight:700;margin-bottom:4px">'
    +(n.tipo==='debito'?'Nota de d\u00e9bito':'Nota de cr\u00e9dito')+' '
    +(n.nota_num?('#'+ncrEsc(n.nota_num)):('\u00b7 solicitud S-'+n.id))
    +' <span class="badge '+es.c+'" style="vertical-align:middle">'+es.t+'</span></h2>'
    +'<p style="font-size:12px;opacity:.75">'+ncrEsc(n.cardname||n.cardcode)
    +(n.docnum?(' \u00b7 factura #'+n.docnum):'')+' \u00b7 '+ncrEsc(n.motivo)+'</p></div>';

  h+='<div style="display:grid;grid-template-columns:repeat(4,1fr);gap:12px;margin-bottom:14px">'
    +'<div class="kpi"><div class="kpi-lbl">Monto</div><div class="kpi-val">'+ncrMon(n.monto)+'</div></div>'
    +'<div class="kpi"><div class="kpi-lbl">Factura</div><div class="kpi-val">'+ncrMon(n.total_factura)+'</div></div>'
    +'<div class="kpi"><div class="kpi-lbl">Grupo</div><div class="kpi-val" style="font-size:15px">'+ncrEsc(n.grupo||'\u2014')+'</div></div>'
    +'<div class="kpi"><div class="kpi-lbl">Vendedor</div><div class="kpi-val" style="font-size:14px">'+ncrEsc(n.vendedor||'\u2014')+'</div></div>'
    +'</div>';

  h+='<div class="card" style="margin-bottom:14px"><div class="ct" style="margin-bottom:10px">Generales</div>';
  h+='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:12px;font-size:13px">';
  [['C\u00f3digo',n.cardcode],['Nombre',n.cardname],['Pa\u00eds',n.pais],
   ['Fecha de factura',fmtD(n.fecha_factura)],['Grupo',(n.grupo||'')+' '+(n.grupo_nombre||'')],
   ['Solicitada',fmtD(n.creado_en)]].forEach(function(p){
    h+='<div><div style="font-size:11px;color:var(--text3);text-transform:uppercase;letter-spacing:.04em;font-weight:600">'
      +p[0]+'</div><div>'+ncrEsc(p[1]||'\u2014')+'</div></div>';
  });
  h+='</div></div>';

  if(lin.length){
    h+='<div class="card" style="margin-bottom:14px"><div class="ct" style="margin-bottom:10px">'
      +'L\u00edneas afectadas ('+lin.length+')</div><div style="overflow-x:auto"><table class="tbl">';
    h+='<tr><th>SKU</th><th>Descripci\u00f3n</th><th style="text-align:right">Facturado</th>'
      +'<th style="text-align:right">Afectado</th><th style="text-align:right">Precio</th>'
      +'<th style="text-align:right">Monto</th><th>Condici\u00f3n</th><th>Nota</th></tr>';
    lin.forEach(function(l){
      h+='<tr><td style="font-family:monospace;font-size:12px">'+ncrEsc(l.itemcode)+'</td>'
        +'<td>'+ncrEsc(l.dscription)+'</td>'
        +'<td style="text-align:right">'+ncrNum(l.cant_facturada).toLocaleString('en-US')+'</td>'
        +'<td style="text-align:right;font-weight:700">'+ncrNum(l.cant_afectada).toLocaleString('en-US')+'</td>'
        +'<td style="text-align:right">'+ncrMon(l.precio)+'</td>'
        +'<td style="text-align:right;font-weight:700">'+ncrMon(l.monto)+'</td>'
        +'<td style="font-size:12px">'+ncrEsc(l.condicion||'')+'</td>'
        +'<td style="font-size:12px;color:var(--text2)">'+ncrEsc(l.nota||'')+'</td></tr>';
    });
    h+='</table></div></div>';
  }

  if(n.comentarios){
    h+='<div class="card" style="margin-bottom:14px"><div class="ct" style="margin-bottom:8px">Comentarios</div>'
      +'<p style="font-size:13px;color:var(--text2);white-space:pre-wrap">'+ncrEsc(n.comentarios)+'</p></div>';
  }

  // Adjuntos. Van ANTES de las firmas a proposito: quien aprueba tiene que
  // haber visto las pruebas antes de llegar al boton de aprobar.
  h+='<div class="card" style="margin-bottom:14px">';
  h+='<div class="ct" style="margin-bottom:10px">Adjuntos del reclamo'
    +(adj.length?(' ('+adj.length+')'):'')+'</div>';
  if(!adj.length){
    h+='<div style="font-size:12.5px;color:var(--text3)">'
      +'Esta solicitud no trae fotos ni documentos.'
      +(ncrPuedeAprobar()&&n.estado==='pendiente'
        ?' Si el reclamo necesita constancia, devu\u00e9lvela con el motivo.':'')
      +'</div>';
  } else {
    // Tamaño medio y zoom al pasar el mouse: quien aprueba tiene que poder
    // mirar el reclamo sin abrir cada foto en otra pestaña. Se reutiliza
    // _hvShow/_hvMove/_hvHide de kennedy-1.js, el mismo zoom del inventario,
    // y el clic abre la foto a pantalla completa con imgZoom.
    var hv=(typeof _HV_ATTRS==='string') ? _HV_ATTRS : '';
    h+='<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:10px">';
    adj.forEach(function(a){
      var img=ncrEsImagen(a.mime,a.nombre);
      h+='<div style="border:1px solid var(--border);border-radius:var(--r2);overflow:hidden;'
        +'background:var(--surface2)">';
      if(img){
        h+='<img src="'+ncrEsc(a.url)+'" loading="lazy" '
          +'title="Pasa el mouse para verla grande \u00b7 clic para ampliar"'+hv
          +' onclick="'+(typeof imgZoom==='function'
              ? 'imgZoom(this.src)'
              : "window.open(this.src,'_blank')")+'" '
          +'style="width:100%;height:110px;object-fit:cover;display:block;cursor:zoom-in">';
      } else {
        h+='<a href="'+ncrEsc(a.url)+'" target="_blank" rel="noopener" '
          +'style="height:110px;display:flex;align-items:center;justify-content:center;'
          +'font-size:32px;text-decoration:none">\ud83d\udcc4</a>';
      }
      h+='<div style="padding:7px 9px">'
        +'<div style="font-size:11px;font-weight:600;white-space:nowrap;overflow:hidden;'
        +'text-overflow:ellipsis" title="'+ncrEsc(a.nombre)+'">'+ncrEsc(a.nombre)+'</div>';
      if(a.descripcion){
        h+='<div style="font-size:10.5px;color:var(--text2);margin-top:2px;white-space:nowrap;'
          +'overflow:hidden;text-overflow:ellipsis">'+ncrEsc(a.descripcion)+'</div>';
      }
      h+='<div style="font-size:10px;color:var(--text3);margin-top:3px">'
        +ncrTam(a.tamano)+' \u00b7 '+ncrEsc(String(a.subido_por||'').split('@')[0])+'</div>';
      h+='</div></div>';
    });
    h+='</div>';
    h+='<div style="font-size:11.5px;color:var(--text3);margin-top:10px">'
      +'Pasa el mouse por una foto para verla grande; p\u00falsala para ampliarla.</div>';
  }
  h+='</div>';

  // Firmas
  h+='<div class="card" style="margin-bottom:14px"><div class="ct" style="margin-bottom:10px">Trazabilidad</div>';
  h+='<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:12px;font-size:13px">';
  [['Solicitado por',n.solicitado_por,n.solicitado_en],
   ['Revisado por',  n.revisado_por,  n.revisado_en],
   ['Aprobado por',  n.aprobado_por,  n.aprobado_en]].forEach(function(p){
    h+='<div style="border:1px solid var(--border);border-radius:var(--r2);padding:11px 13px;background:var(--surface2)">'
      +'<div style="font-size:11px;color:var(--text3);text-transform:uppercase;letter-spacing:.04em;font-weight:600">'+p[0]+'</div>'
      +'<div style="font-weight:600;margin-top:3px">'+ncrEsc(p[1]||'\u2014')+'</div>'
      +'<div style="font-size:12px;color:var(--text3)">'+(p[2]?fmtD(p[2]):'')+'</div></div>';
  });
  h+='</div>';
  if(n.motivo_rechazo){
    h+='<div style="margin-top:12px;color:var(--red);font-size:13px"><b>Motivo de la '
      +(n.estado==='anulada'?'anulaci\u00f3n':'rechazo')+':</b> '+ncrEsc(n.motivo_rechazo)+'</div>';
  }
  h+='</div>';

  // ── Paso 1: revisar (Dan o Jimmy) ──
  if(ncrPuedeRevisar() && n.estado==='pendiente'){
    h+='<div class="card"><div class="ct" style="margin-bottom:10px">Revisi\u00f3n</div>'
      +'<div style="font-size:12.5px;color:var(--text3);margin-bottom:10px">'
      +'Al revisarla pasa a contabilidad, que la aprueba y la sube a SAP.</div>'
      +'<div style="display:flex;gap:8px;flex-wrap:wrap">'
      +'<button class="btn btn-p" onclick="ncrRevisar('+n.id+')">\u2713 Revisada \u00b7 pasar a contabilidad</button>'
      +'<button class="btn" style="background:var(--red);color:#fff;border-color:var(--red)" '
      +'onclick="ncrRechazar('+n.id+')">\u2715 Rechazar</button>'
      +'</div></div>';
  }

  // ── Paso 2: aprobar (contabilidad) ──
  if(ncrPuedeAprobar() && n.estado==='revisada'){
    h+='<div class="card"><div class="ct" style="margin-bottom:10px">Aprobaci\u00f3n de contabilidad</div>'
      +'<div style="font-size:12.5px;color:var(--text3);margin-bottom:10px">'
      +'Revisada por <b>'+ncrEsc(n.revisado_por||'')+'</b>. Al aprobarla se preparan '
      +'las l\u00edneas para SAP y podr\u00e1s revisarlas antes de enviarlas.</div>'
      +'<div style="display:flex;gap:8px;flex-wrap:wrap">'
      +'<button class="btn btn-p" onclick="ncrAprobar('+n.id+')">\u2713 Aprobar</button>'
      +'<button class="btn" style="background:var(--red);color:#fff;border-color:var(--red)" '
      +'onclick="ncrRechazar('+n.id+')">\u2715 Rechazar</button>'
      +'</div></div>';
  }

  // ── Paso 3: el documento que ira a SAP ──
  // El panel de SAP solo tiene sentido una vez aprobada. Si la nota esta en un
  // paso anterior se dice en que paso esta, en vez de no mostrar nada: la
  // ausencia muda es lo que hace perder el tiempo buscando el boton.
  if(n.estado==='aprobada' || n.estado==='enviada' || n.docnum_sap){
    h+='<div id="ncr-sap"></div>';
    setTimeout(function(){ ncrSapPanel(n); }, 30);
  } else if(ncrPuedeEnviarSap() && ['pendiente','revisada'].indexOf(n.estado)>=0){
    h+='<div class="card"><div class="ct" style="margin-bottom:6px">Documento para SAP</div>'
      +'<div style="font-size:12.5px;color:var(--text3)">'
      +(n.estado==='pendiente'
        ? 'Esta nota todav\u00eda no la ha revisado gerencia. Cuando la revisen, '
          +'contabilidad la aprueba y entonces se puede enviar a SAP.'
        : 'Revisada por <b>'+ncrEsc(n.revisado_por||'')+'</b>. Falta aprobarla '
          +'(bot\u00f3n de arriba) para poder enviarla a SAP.')
      +'</div></div>';
  }
  if(ncrPuedeAprobar() && n.estado==='aprobada'){
    h+='<div class="card"><div class="ct" style="margin-bottom:10px">Anular</div>'
      +'<div style="font-size:12.5px;color:var(--text3);margin-bottom:10px">'
      +'Si esta nota ya no procede, an\u00falala. Queda en el historial con el motivo; '
      +'no se borra.</div>'
      +'<button class="btn" style="background:var(--red);color:#fff;border-color:var(--red)" '
      +'onclick="ncrAnular('+n.id+')">Anular nota</button></div>';
  }

  c.innerHTML=h;
}

// Vuelve a abrir un borrador en el formulario, con sus lineas.
async function ncrEditar(id){
  var r=await Promise.all([
    q('solicitudes_nota','select=*&id=eq.'+id+'&limit=1'),
    q('solicitudes_nota_lineas','select=*&nota_id=eq.'+id+'&order=linenum'),
    q('solicitudes_nota_adjuntos','select=*&nota_id=eq.'+id+'&order=id')
  ]);
  var n=(r[0]&&r[0][0])||null, lin=r[1]||[], adj=r[2]||[];
  if(!n){ alert('No encontr\u00e9 esa nota.'); return; }

  NCR = ncrNuevoEstado();
  ['id','tipo','motivo','base','grupo','grupo_nombre','grupo_auto','cardcode','cardname',
   'pais','slpcode','vendedor','docnum','monto','comentarios','nota_num','estado','total_factura']
    .forEach(function(k){ if(n[k]!=null) NCR[k]=n[k]; });
  NCR.fecha_factura = String(n.fecha_factura||'').slice(0,10);
  NCR._facturaCargada = !!n.docnum;
  NCR.adjuntos = adj.map(function(a){
    return {nombre:a.nombre, mime:a.mime, tamano:a.tamano, ruta:a.ruta,
            url:a.url, descripcion:a.descripcion||'', subido_por:a.subido_por};
  });

  // Se recargan las lineas de la factura para poder seguir marcando otras, y
  // se vuelcan encima las que ya estaban pedidas.
  if(n.docnum && n.base==='lineas'){
    ncrRenderForm();
    var i=document.getElementById('ncr-docnum'); if(i) i.value=n.docnum;
    await ncrCargarFactura();
    lin.forEach(function(g){
      var t=NCR.lineas.filter(function(l){
        return (g.linenum!=null && l.linenum===g.linenum) || l.itemcode===g.itemcode;
      })[0];
      if(!t) return;
      t._sel=true; t.cant_afectada=ncrNum(g.cant_afectada); t.precio=ncrNum(g.precio);
      t.monto=ncrNum(g.monto); t.condicion=g.condicion||t.condicion;
      t.nota=g.nota||''; t.grupo=g.grupo||t.grupo; t._montoManual=true;
    });
    NCR.monto=ncrNum(n.monto);
    NCR.grupo=n.grupo||NCR.grupo;
  }
  ncrRenderForm();
  ncrMsg('Editando el borrador S-'+id+'.','info');
}

// A quien se le manda la nota aprobada para que la capture.
var NCR_CONTABILIDAD = 'contabilidad2@kennedyzl.com';

// ── Paso 1: Dan o Jimmy revisan ────────────────────────────────────────
async function ncrRevisar(id){
  if(!ncrPuedeRevisar()) return;
  if(!confirm('\u00bfMarcar como revisada?\n\nPasa a contabilidad ('
    +NCR_CONTABILIDAD+'), que la aprueba y la sube a SAP.')) return;
  try{
    await ncrEscribir('PATCH','solicitudes_nota?id=eq.'+id, {
      estado:'revisada', revisado_por:ncrYo(), revisado_en:new Date().toISOString()
    });
  }catch(e){ ncrMsg('No se pudo revisar: '+ncrEsc(e.message||e),'err'); return; }
  ncrVer(id);
  // El correo va aparte: si falla, la nota ya quedo revisada igual.
  try{ await ncrEnviarContabilidad(id, 'revisada'); }
  catch(e){
    setTimeout(function(){
      ncrMsg('Qued\u00f3 revisada, pero el aviso a '+NCR_CONTABILIDAD
        +' no sali\u00f3: '+ncrEsc(e.message||e),'err');
    }, 700);
  }
}


/* ══════════════════════════════════════════════════════════════════════════
   EL DOCUMENTO QUE IRA A SAP
   ---------------------------------------------------------------------------
   En SAP la nota sale como A/R Credit Memo de tipo SERVICIO: una linea POR
   CUENTA CONTABLE, no por articulo. Si la factura mezclaba ropa y alfombras,
   son dos lineas.

   Las propone el portal agrupando por el departamento del articulo, pero
   contabilidad puede corregir cuenta, descripcion y monto antes de enviar:
   es quien firma.
   ══════════════════════════════════════════════════════════════════════════ */

// Lo que cabe en la descripcion de una linea en SAP (RIN1.Dscription). Si se
// pasa, SAP rechaza el documento entero con un error ilegible, asi que el
// limite se ve aqui mientras se edita.
var NCR_MAX_DESC = 100;

var NCR_CUENTAS=[];        // de la tabla cuentas_nota
var NCR_SAP_LINEAS=[];
var NCR_SAP_NOTA=null;

async function ncrCuentas(){
  if(NCR_CUENTAS.length) return NCR_CUENTAS;
  try{
    NCR_CUENTAS = await q('cuentas_nota',
      'select=cuenta,nombre,claves,por_cliente&activo=is.true&order=orden') || [];
  }catch(e){ NCR_CUENTAS=[]; }
  return NCR_CUENTAS;
}

function _ncrNorm(t){
  return String(t||'').toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim();
}

// De que cuenta es un articulo, a partir de su departamento o su grupo.
function ncrCuentaDe(texto){
  var t=_ncrNorm(texto);
  if(!t) return null;
  for(var i=0;i<NCR_CUENTAS.length;i++){
    var c=NCR_CUENTAS[i];
    if(c.por_cliente) continue;                 // esas no salen del articulo
    var cl=String(c.claves||'').split(',');
    for(var j=0;j<cl.length;j++){
      var k=_ncrNorm(cl[j]);
      if(k && t.indexOf(k)>=0) return c;
    }
  }
  return null;
}

// La descripcion que ve el cliente en SAP, con el formato que usa la empresa:
//   MOTIVO S/F.<factura> S/REF. <sku> <cant>PCS A <precio>
function ncrDescLinea(n, lins){
  var ref=lins.map(function(l){
    var p=Number(l.precio||0);
    // ncrNum, no ncrN: ese formateador no existe en este modulo y la
    // excepcion tumbaba el panel entero antes de pintar el boton.
    var c=ncrNum(l.cant_afectada||0);
    return String(l.itemcode||'')+' '+(c===Math.round(c)?String(Math.round(c)):c.toFixed(2))
      +'PCS A '+(p?p.toFixed(2):'0.00');
  }).join('; ');
  var t = String(n.motivo||'').toUpperCase()
    + (n.docnum ? (' S/F.'+n.docnum) : '')
    + (ref ? (' S/REF. '+ref) : '');
  // Con muchos articulos el texto se pasa del campo de SAP. Se corta en el
  // ultimo punto y coma para no partir una referencia por la mitad.
  if(t.length > NCR_MAX_DESC){
    var c=t.slice(0, NCR_MAX_DESC), p=c.lastIndexOf(';');
    t = (p > NCR_MAX_DESC*0.5 ? c.slice(0,p) : c).replace(/[;\s]+$/,'');
  }
  return t;
}

// Propone las lineas agrupando por cuenta. No las guarda: solo las sugiere.
function ncrProponerSap(n, lineas){
  var porCuenta={};
  (lineas||[]).forEach(function(l){
    var c = ncrCuentaDe(l.grupo || l.dscription || '') ;
    var cod = c ? c.cuenta : (n.grupo || '');
    (porCuenta[cod] = porCuenta[cod] || []).push(l);
  });
  var out=[];
  Object.keys(porCuenta).forEach(function(cod, i){
    var g=porCuenta[cod];
    var cta=NCR_CUENTAS.filter(function(c){ return c.cuenta===cod; })[0];
    out.push({
      orden:i, cuenta:cod, cuenta_nombre:(cta?cta.nombre:(n.grupo_nombre||'')),
      descripcion: ncrDescLinea(n, g),
      monto: Math.round(g.reduce(function(a,b){ return a+Number(b.monto||0); },0)*100)/100
    });
  });
  // Sin lineas de factura (gastos bancarios, por ejemplo): una sola linea con
  // el motivo y el monto de la nota.
  if(!out.length){
    out.push({orden:0, cuenta:(n.grupo||''), cuenta_nombre:(n.grupo_nombre||''),
      descripcion: ncrDescLinea(n, []), monto: Number(n.monto||0)});
  }
  return out;
}

async function ncrSapPanel(n){
  var c=document.getElementById('ncr-sap'); if(!c) return;
  NCR_SAP_NOTA=n;
  await ncrCuentas();

  // Lo que ya este guardado manda; si no hay nada, se propone.
  var guardadas=[];
  try{
    guardadas = await q('solicitudes_nota_sap',
      'select=*&nota_id=eq.'+n.id+'&order=orden') || [];
  }catch(e){}
  if(guardadas.length){
    NCR_SAP_LINEAS = guardadas.map(function(x){
      return {id:x.id, orden:x.orden, cuenta:x.cuenta, cuenta_nombre:x.cuenta_nombre,
              descripcion:x.descripcion, monto:Number(x.monto||0)};
    });
  } else {
    var lins=[];
    try{ lins = await q('solicitudes_nota_lineas','select=*&nota_id=eq.'+n.id+'&order=linenum') || []; }catch(e){}
    NCR_SAP_LINEAS = ncrProponerSap(n, lins);
  }
  ncrSapPintar();
}

function ncrSapPintar(){
  var c=document.getElementById('ncr-sap'); if(!c) return;
  var n=NCR_SAP_NOTA||{};
  var puede = ncrPuedeEnviarSap() && !n.docnum_sap && n.estado!=='enviada';
  var suma = Math.round(NCR_SAP_LINEAS.reduce(function(a,l){ return a+Number(l.monto||0); },0)*100)/100;
  var pedido = Math.round(Number(n.monto||0)*100)/100;

  var h='<div class="card">';
  h+='<div class="ct" style="margin-bottom:4px">Documento para SAP</div>';

  if(n.docnum_sap){
    h+='<div style="padding:11px 13px;border-radius:9px;background:#EAF3DE;color:#27500A;'
      +'font-size:13px;margin-bottom:12px">\u2713 Creada en SAP como nota <b>'
      +ncrEsc(n.docnum_sap)+'</b>'+(n.enviado_en?(' el '+fmtD(n.enviado_en)):'')+'.</div>';
  } else if(n.error_sap){
    h+='<div style="padding:11px 13px;border-radius:9px;background:#FCEBEB;color:#791F1F;'
      +'font-size:12.5px;margin-bottom:12px"><b>SAP rechaz\u00f3 la nota:</b><br>'
      +ncrEsc(n.error_sap)+'</div>';
  } else {
    h+='<div style="font-size:12.5px;color:var(--text3);margin-bottom:12px">'
      +'Una l\u00ednea por cuenta contable. Revisa cuenta, descripci\u00f3n y monto: '
      +'es lo que se va a crear en SAP.</div>';
  }

  h+='<div style="overflow-x:auto"><table class="tbl" style="min-width:720px">'
    +'<tr><th style="width:230px">Cuenta</th><th>Descripci\u00f3n</th>'
    +'<th style="text-align:right;width:120px">Monto</th>'+(puede?'<th></th>':'')+'</tr>';

  NCR_SAP_LINEAS.forEach(function(l,i){
    h+='<tr><td>';
    if(puede){
      h+='<select class="inp" style="font-size:12px" onchange="ncrSapSet('+i+',\'cuenta\',this.value)">'
        +NCR_CUENTAS.map(function(c){
            return '<option value="'+ncrEsc(c.cuenta)+'"'+(c.cuenta===l.cuenta?' selected':'')+'>'
              +ncrEsc(c.cuenta+' \u00b7 '+c.nombre)+'</option>';
          }).join('')+'</select>';
    } else {
      h+='<span class="mono" style="font-size:12px">'+ncrEsc(l.cuenta)+'</span>'
        +'<div style="font-size:11px;color:var(--text3)">'+ncrEsc(l.cuenta_nombre||'')+'</div>';
    }
    h+='</td><td>';
    if(puede){
      var _len=String(l.descripcion||'').trim().length;
      var _mal = _len<2 || _len>NCR_MAX_DESC;
      h+='<textarea class="inp" rows="2" maxlength="'+NCR_MAX_DESC+'" '
        +'style="font-size:12px;width:100%;resize:vertical'
        +(_mal?';border-color:var(--red)':'')+'" '
        +'oninput="ncrSapSet('+i+',\'descripcion\',this.value)">'+ncrEsc(l.descripcion)+'</textarea>'
        +'<div style="font-size:11px;color:'+(_mal?'var(--red)':'var(--text3)')+'">'
        +_len+' / '+NCR_MAX_DESC
        +(_len<2 ? ' \u00b7 SAP la rechaza vac\u00eda'
                 : (_len>NCR_MAX_DESC ? ' \u00b7 se pasa del l\u00edmite de SAP' : ''))
        +'</div>';
    } else {
      h+='<span style="font-size:12.5px">'+ncrEsc(l.descripcion)+'</span>';
    }
    h+='</td><td style="text-align:right">';
    if(puede){
      h+='<input class="inp" type="number" step="0.01" style="width:108px;text-align:right" '
        +'value="'+Number(l.monto||0).toFixed(2)+'" '
        +'onchange="ncrSapSet('+i+',\'monto\',this.value)">';
    } else {
      h+='<b>'+ncrMon(l.monto)+'</b>';
    }
    h+='</td>';
    if(puede){
      h+='<td style="text-align:center">'
        +(NCR_SAP_LINEAS.length>1
          ? '<span style="color:var(--red);cursor:pointer" onclick="ncrSapQuitar('+i+')">\u2715</span>'
          : '')+'</td>';
    }
    h+='</tr>';
  });
  h+='</table></div>';

  // El cuadre: el worker rechaza la nota si no coincide, asi que se ve aqui.
  var cuadra = Math.abs(suma-pedido) <= 0.02;
  h+='<div style="display:flex;gap:10px;align-items:center;flex-wrap:wrap;margin-top:10px">'
    +'<span style="font-size:13px">Suma de l\u00edneas: <b>'+ncrMon(suma)+'</b></span>'
    +'<span style="font-size:13px;color:var(--text3)">Nota aprobada: '+ncrMon(pedido)+'</span>'
    +(cuadra ? '<span style="font-size:12px;color:var(--green)">\u2713 cuadra</span>'
             : '<span style="font-size:12px;color:#991B1B;font-weight:700">'
               +'\u26a0 difiere en '+ncrMon(Math.abs(suma-pedido))+'</span>')
    +'</div>';

  if(!puede && !n.docnum_sap && n.estado!=='enviada'){
    h+='<div style="margin-top:12px;padding:10px 12px;border-radius:9px;'
      +'background:var(--bg);font-size:12.5px;color:var(--text3)">'
      +'Solo <b>contabilidad</b> y <b>Dan</b> pueden enviar la nota a SAP. '
      +'Entraste como <b>'+ncrEsc(ncrUsuario()||'(sin usuario)')+'</b>.</div>';
  }
  if(puede){
    h+='<div style="margin-top:12px">'
      +'<div style="font-size:11px;color:var(--text3);text-transform:uppercase;'
      +'letter-spacing:.04em;font-weight:700;margin-bottom:5px">Comentarios (van al campo Remarks de SAP)</div>'
      +'<textarea id="ncr-remarks" class="inp" rows="3" style="width:100%;resize:vertical" '
      +'placeholder="Lo que deba quedar anotado en el documento">'
      +ncrEsc(n.remarks||'')+'</textarea></div>';
    h+='<div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:12px">'
      +'<button class="btn btn-sm" onclick="ncrSapAnadir()">+ A\u00f1adir l\u00ednea</button>'
      +'<button class="btn btn-sm" onclick="ncrSapGuardar(false)">Guardar sin enviar</button>'
      +'<button class="btn btn-p" style="margin-left:auto;background:#166534" '
      +(cuadra?'':'disabled title="Las l\u00edneas no cuadran con el monto aprobado"')
      +' onclick="ncrSapEnviar()">\u2191 Enviar a SAP</button>'
      +'</div>';
  }
  h+='</div>';
  c.innerHTML=h;
}

function ncrSapSet(i,campo,v){
  var l=NCR_SAP_LINEAS[i]; if(!l) return;
  if(campo==='monto') l.monto=Number(v)||0;
  else l[campo]=v;
  if(campo==='cuenta'){
    var c=NCR_CUENTAS.filter(function(x){ return x.cuenta===v; })[0];
    l.cuenta_nombre = c?c.nombre:'';
  }
  // Solo el monto y la cuenta repintan: repintar al teclear la descripcion
  // haria perder el cursor en cada letra.
  if(campo!=='descripcion') ncrSapPintar();
}
function ncrSapQuitar(i){ NCR_SAP_LINEAS.splice(i,1); ncrSapPintar(); }
function ncrSapAnadir(){
  var c=NCR_CUENTAS[0]||{};
  NCR_SAP_LINEAS.push({orden:NCR_SAP_LINEAS.length, cuenta:c.cuenta||'',
    cuenta_nombre:c.nombre||'', descripcion:'', monto:0});
  ncrSapPintar();
}

async function ncrSapGuardar(silencio){
  var n=NCR_SAP_NOTA; if(!n) return false;
  var rem=(document.getElementById('ncr-remarks')||{}).value||'';
  try{
    // Se reemplazan todas: es mas simple y seguro que llevar altas y bajas.
    await ncrEscribir('DELETE','solicitudes_nota_sap?nota_id=eq.'+n.id);
    if(NCR_SAP_LINEAS.length){
      await ncrEscribir('POST','solicitudes_nota_sap', NCR_SAP_LINEAS.map(function(l,i){
        return {nota_id:n.id, orden:i, cuenta:l.cuenta, cuenta_nombre:l.cuenta_nombre||'',
                descripcion:String(l.descripcion||'').trim(), monto:Number(l.monto||0)};
      }));
    }
    await ncrEscribir('PATCH','solicitudes_nota?id=eq.'+n.id, {remarks:rem});
    n.remarks=rem;
    if(!silencio) ncrMsg('\u2713 Guardado. A\u00fan no se ha enviado a SAP.','ok');
    return true;
  }catch(e){
    ncrMsg('No se pudo guardar: '+ncrEsc(e.message||e),'err');
    return false;
  }
}

async function ncrSapEnviar(){
  var n=NCR_SAP_NOTA; if(!n || !ncrPuedeEnviarSap()) return;
  if(n.docnum_sap){ alert('Esta nota ya est\u00e1 en SAP como '+n.docnum_sap+'.'); return; }

  var suma=Math.round(NCR_SAP_LINEAS.reduce(function(a,l){ return a+Number(l.monto||0); },0)*100)/100;
  // SAP exige al menos 2 caracteres en la descripcion y rechaza el documento
  // entero si falta en una sola linea. Se comprueba aqui, con el numero de
  // linea, en vez de dejar que SAP conteste "-1116 (40020)".
  var malas=[];
  NCR_SAP_LINEAS.forEach(function(l,i){
    if(!l.cuenta) malas.push('L\u00ednea '+(i+1)+': falta la cuenta.');
    else if(String(l.descripcion||'').trim().length<2)
      malas.push('L\u00ednea '+(i+1)+' ('+l.cuenta+'): la descripci\u00f3n debe tener '
        +'al menos 2 caracteres.');
    else if(String(l.descripcion||'').trim().length>NCR_MAX_DESC)
      malas.push('L\u00ednea '+(i+1)+' ('+l.cuenta+'): la descripci\u00f3n tiene '
        +String(l.descripcion).trim().length+' caracteres y SAP admite '+NCR_MAX_DESC+'.');
  });
  if(malas.length){ alert('No se puede enviar:\n\n'+malas.join('\n')); return; }

  var det=NCR_SAP_LINEAS.map(function(l){ return '   '+l.cuenta+'   '+ncrMon(l.monto); }).join('\n');
  if(!confirm('Se crear\u00e1 en SAP una nota de '
    +(n.tipo==='debito'?'D\u00c9BITO':'CR\u00c9DITO')+' para '+(n.cardname||n.cardcode)+':\n\n'
    +det+'\n   ----------------\n   TOTAL '+ncrMon(suma)
    +'\n\nEsto crea un documento contable y NO se puede deshacer desde el portal.\n\n'
    +'\u00bfContinuar?')) return;

  if(!await ncrSapGuardar(true)) return;
  try{
    await ncrEscribir('PATCH','solicitudes_nota?id=eq.'+n.id, {
      enviar_sap:true, error_sap:null,
      enviado_por:ncrYo()
    });
    ncrMsg('\u2713 Enviada. El worker la crea en SAP en unos segundos; '
      +'actualiza para ver el n\u00famero.','ok');
    setTimeout(function(){ ncrVer(n.id); }, 6000);
  }catch(e){
    ncrMsg('No se pudo enviar: '+ncrEsc(e.message||e),'err');
  }
}

async function ncrAprobar(id){
  if(!ncrPuedeAprobar()) return;
  if(!confirm('\u00bfAprobar esta nota?\n\nAl aprobarla se env\u00eda el PDF a '
    +NCR_CONTABILIDAD+' para que la procese.')) return;
  try{
    await ncrEscribir('PATCH','solicitudes_nota?id=eq.'+id, {
      estado:'aprobada', aprobado_por:ncrYo(), aprobado_en:new Date().toISOString(),
      revisado_por:ncrYo(), revisado_en:new Date().toISOString()
    });
  }catch(e){
    ncrMsg('No se pudo aprobar: '+ncrEsc(e.message||e),'err');
    return;
  }

  // El correo va DESPUES de aprobar y en su propio try. Si fallara el envio,
  // la nota ya quedo aprobada: se avisa para mandarla a mano, pero no se
  // deshace la aprobacion ni se deja al usuario pensando que no paso nada.
  ncrVer(id);
  try{
    await ncrEnviarContabilidad(id);
  }catch(e){
    setTimeout(function(){
      ncrMsg('La nota qued\u00f3 aprobada, pero el correo a '+NCR_CONTABILIDAD
        +' no sali\u00f3: '+ncrEsc(e.message||e)
        +'<br>Desc\u00e1rgala y mándala a mano, o pulsa <b>Reenviar a contabilidad</b>.','err');
    }, 700);
  }
}

// Encola el correo con el PDF adjunto. No lo manda directo: usa `correos_queue`,
// la misma cola que el resto del portal, que el worker vacia cada minuto. Asi
// el envio no depende de que el navegador siga abierto ni de que la red del
// vendedor aguante.
// `modo` = 'revisada' cuando lo manda gerencia al pasarla a contabilidad;
// sin modo, es el aviso de que ya quedo aprobada.
async function ncrEnviarContabilidad(id, modo){
  var blob = await ncrPdfBlob(id);

  // base64 sin la cabecera "data:...;base64,"
  var b64 = await new Promise(function(res, rej){
    var fr=new FileReader();
    fr.onload=function(){
      var s=String(fr.result||'');
      res(s.slice(s.indexOf(',')+1));
    };
    fr.onerror=function(){ rej(new Error('no se pudo leer el PDF')); };
    fr.readAsDataURL(blob);
  });

  var d=NCR_ENVIO||{};
  var nombre='nota-'+(d.tipo==='debito'?'debito':'credito')+'-'
    +(d.nota_num?String(d.nota_num).replace(/[^\w\-]/g,''):('S'+id))
    +(d.docnum?('-fact'+d.docnum):'')+'.pdf';

  // Dos momentos distintos con el mismo correo: cuando gerencia la REVISA
  // -y queda pendiente de contabilidad- y cuando ya esta aprobada.
  var _rev = (modo === 'revisada');

  var titulo=(d.tipo==='debito'?'Nota de d\u00e9bito':'Nota de cr\u00e9dito')
    +(_rev?' POR APROBAR':' aprobada')+' \u00b7 '+(d.cardname||d.cardcode||'')
    +(d.docnum?(' \u00b7 factura #'+d.docnum):'');

  // La marca <!--HTML--> le dice al worker que el cuerpo YA viene en HTML y no
  // hay que escaparlo. Sin ella llegaban las etiquetas como texto, y el
  // cliente de correo enlazaba las direcciones de dentro rompiendo la tabla.
  var cuerpo=
     '<!--HTML-->'
    +(_rev
       ? ('<p>La solicitud <b>S-'+id+'</b> fue revisada por <b>'+ncrEsc(ncrYo())
          +'</b> y queda <b>pendiente de tu aprobaci\u00f3n</b> en el portal. '
          +'El formulario va adjunto.</p>')
       : '<p>Se aprob\u00f3 la solicitud <b>S-'+id+'</b>. El formulario va adjunto.</p>')
    +'<table cellpadding="4" style="font-family:Arial,sans-serif;font-size:13px">'
    +'<tr><td><b>Cliente</b></td><td>'+ncrEsc((d.cardcode||'')+'  '+(d.cardname||''))+'</td></tr>'
    +(d.docnum?('<tr><td><b>Factura</b></td><td>#'+ncrEsc(d.docnum)+'</td></tr>'):'')
    +'<tr><td><b>Motivo</b></td><td>'+ncrEsc(d.motivo||'')+'</td></tr>'
    +'<tr><td><b>Grupo</b></td><td>'+ncrEsc((d.grupo||'')+' '+(d.grupo_nombre||''))+'</td></tr>'
    +'<tr><td><b>Monto</b></td><td><b>'+ncrMon(d.monto)+'</b></td></tr>'
    +'<tr><td><b>Solicitada por</b></td><td>'+ncrEsc(d.solicitado_por||'')+'</td></tr>'
    +'<tr><td><b>Aprobada por</b></td><td>'+ncrEsc(ncrYo())+'</td></tr>'
    +'</table>'
    +(d.comentarios?('<p><b>Comentarios:</b><br>'+ncrEsc(d.comentarios)+'</p>'):'')
    +'<p style="color:#888;font-size:12px">Enviado autom\u00e1ticamente por el '
    +'Portal de Ventas de Kennedy Center.</p>';

  var r=await fetch(SB+'/rest/v1/correos_queue',{
    method:'POST',
    headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),
             'Content-Type':'application/json','Prefer':'return=minimal'},
    body:JSON.stringify({
      docnum: String(d.docnum||''),
      para_lista: [NCR_CONTABILIDAD],
      para_email: NCR_CONTABILIDAD,
      asunto: titulo,
      cuerpo: cuerpo,
      adjuntos: [{nombre:nombre, mime:'application/pdf', contenido:b64}],
      de_nombre: 'Portal de Ventas',
      de_email: ncrYo(),
      origen: 'nota_credito',
      estado: 'pendiente'
    })
  });
  if(!r.ok) throw new Error('HTTP '+r.status+': '+(await r.text()).slice(0,200));

  setTimeout(function(){
    ncrMsg('\u2713 Nota aprobada. El PDF sali\u00f3 hacia '+NCR_CONTABILIDAD+'.','ok');
  }, 700);
}

async function ncrRechazar(id){
  if(!ncrPuedeAprobar()) return;
  var m=prompt('Motivo del rechazo:');
  if(m===null) return;
  if(!String(m).trim()){ alert('Escribe el motivo del rechazo.'); return; }
  try{
    await ncrEscribir('PATCH','solicitudes_nota?id=eq.'+id, {
      estado:'rechazada', motivo_rechazo:String(m).trim(),
      revisado_por:ncrYo(), revisado_en:new Date().toISOString()
    });
    ncrVer(id);
  }catch(e){ ncrMsg('No se pudo rechazar: '+ncrEsc(e.message||e),'err'); }
}

// Borra la nota entera: cabecera, lineas, adjuntos de la tabla y los archivos
// del bucket. Las lineas y los adjuntos caen solos por el ON DELETE CASCADE,
// pero los ARCHIVOS no: Storage no sabe nada de esa relacion, asi que hay que
// quitarlos antes o se quedan ocupando espacio para siempre.
//
// Para casi todo es preferible ANULAR: deja rastro. Borrar es para las que se
// crearon por error o duplicadas.
async function ncrBorrar(id){
  if(!ncrPuedeBorrar()) return;

  var lin=[], adj=[];
  try{
    var r=await Promise.all([
      q('solicitudes_nota_lineas','select=id&nota_id=eq.'+id),
      q('solicitudes_nota_adjuntos','select=id,ruta,nombre&nota_id=eq.'+id)
    ]);
    lin=r[0]||[]; adj=r[1]||[];
  }catch(e){}

  var aviso='\u00bfEliminar la solicitud S-'+id+'?\n\n'
    +'Se borrar\u00e1n '+lin.length+' l\u00ednea(s) y '+adj.length+' adjunto(s), '
    +'incluidos los archivos.\nEsto NO se puede deshacer.\n\n'
    +'Si solo quieres dejarla sin efecto, usa Anular: esa s\u00ed queda en el historial.';
  if(!confirm(aviso)) return;
  if(!confirm('Confirma otra vez: se elimina para siempre.')) return;

  ncrMsg('Eliminando\u2026');

  // Primero los archivos: si se borra la fila y luego falla el bucket, ya no
  // queda de donde sacar la ruta.
  var huerfanos=[];
  for(var i=0;i<adj.length;i++){
    if(!adj[i].ruta) continue;
    try{
      var rr=await fetch(SB+'/storage/v1/object/'+NCR_ADJ_BUCKET+'/'+encodeURI(adj[i].ruta),
        {method:'DELETE', headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK()}});
      if(!rr.ok) huerfanos.push(adj[i].nombre||adj[i].ruta);
    }catch(e){ huerfanos.push(adj[i].nombre||adj[i].ruta); }
  }

  try{
    await ncrEscribir('DELETE','solicitudes_nota?id=eq.'+id, null);
  }catch(e){
    ncrMsg('No se pudo eliminar: '+ncrEsc(e.message||e),'err');
    return;
  }

  if(huerfanos.length){
    // Se avisa pero no se bloquea: la nota ya no existe y el archivo suelto en
    // el bucket no molesta a nadie, aunque conviene saberlo.
    alert('La nota se elimin\u00f3, pero '+huerfanos.length+' archivo(s) no se pudieron '
      +'borrar del almacenamiento:\n\n'+huerfanos.join('\n'));
  }

  ncrLista();
  setTimeout(function(){ ncrMsg('\u2713 Solicitud S-'+id+' eliminada.','ok'); }, 300);
}

async function ncrReenviar(id){
  if(!ncrPuedeAprobar()) return;
  if(!confirm('\u00bfVolver a enviar el PDF a '+NCR_CONTABILIDAD+'?')) return;
  ncrMsg('Preparando el env\u00edo\u2026');
  try{
    await ncrEnviarContabilidad(id);
  }catch(e){
    ncrMsg('No se pudo enviar: '+ncrEsc(e.message||e),'err');
  }
}

async function ncrAnular(id){
  if(!ncrPuedeAprobar()) return;
  var m=prompt('Motivo de la anulaci\u00f3n:');
  if(m===null) return;
  if(!String(m).trim()){ alert('Escribe el motivo.'); return; }
  try{
    await ncrEscribir('PATCH','solicitudes_nota?id=eq.'+id, {
      estado:'anulada', motivo_rechazo:String(m).trim(),
      revisado_por:ncrYo(), revisado_en:new Date().toISOString()
    });
    ncrVer(id);
  }catch(e){ ncrMsg('No se pudo anular: '+ncrEsc(e.message||e),'err'); }
}


/* ══════════════════════════════════════════════════════════════════════════
   PDF — mismo formulario que se usa en papel
   ══════════════════════════════════════════════════════════════════════════ */

async function ncrPdf(id){
  var w=window.open('','_blank');
  if(!w){ alert('Permite ventanas emergentes para generar el PDF.'); return; }
  w.document.write('<p style="font-family:Arial;padding:20px">Generando\u2026</p>');

  var r=await Promise.all([
    q('solicitudes_nota','select=*&id=eq.'+id+'&limit=1'),
    q('solicitudes_nota_lineas','select=*&nota_id=eq.'+id+'&order=linenum')
  ]);
  var n=(r[0]&&r[0][0])||null, lin=r[1]||[];
  if(!n){ w.document.body.innerHTML='<p>No encontr\u00e9 la nota.</p>'; return; }

  function cx(on, txt){
    return '<span class="cx"><span class="bx">'+(on?'X':'&nbsp;')+'</span>'+ncrEsc(txt)+'</span>';
  }

  var motivos=(n.tipo==='debito')?NCR_MOTIVOS_DEBITO:NCR_MOTIVOS_CREDITO;

  var css='@page{size:letter;margin:.45in}*{box-sizing:border-box}'
    +'body{font-family:Arial,Helvetica,sans-serif;color:#111;font-size:11px;margin:0}'
    +'h1{font-size:16px;margin:0}h2{font-size:12px;margin:14px 0 5px;background:#e9e9e9;'
    +'padding:4px 7px;border:1px solid #bbb;text-transform:uppercase;letter-spacing:.04em}'
    +'.sub{color:#555;margin:2px 0 8px;font-size:11px}'
    +'.cx{display:inline-block;width:32%;margin:2px 0;font-size:10.5px;vertical-align:top}'
    +'.bx{display:inline-block;width:12px;height:12px;border:1px solid #333;text-align:center;'
    +'line-height:12px;font-weight:bold;margin-right:5px;vertical-align:-2px;font-size:9px}'
    +'table{width:100%;border-collapse:collapse;font-size:10.5px;margin:4px 0}'
    +'th{background:#ececec;border:1px solid #bbb;padding:4px 6px;text-align:left}'
    +'td{border:1px solid #ddd;padding:4px 6px;vertical-align:top}'
    +'.r{text-align:right}.gen td{border:none;padding:3px 0}.gen b{display:inline-block;width:120px}'
    +'.firma{border:1px solid #bbb;height:56px;padding:4px 6px;font-size:9.5px;color:#666;'
    +'vertical-align:bottom;width:33.3%}'
    +'.tot{font-size:14px;font-weight:bold;text-align:right;margin-top:6px}'
    +'.nota{margin-top:12px;font-size:9.5px;color:#444;border-top:1px solid #ccc;padding-top:6px}';

  var h='<!doctype html><html><head><meta charset="utf-8"><title>Solicitud de nota '
    +(n.nota_num||('S-'+n.id))+'</title><style>'+css+'</style></head><body>';

  h+='<h1>KENNEDY CENTER CORP.</h1>';
  h+='<div class="sub">Solicitud de nota &middot; '+(n.nota_num?('N&uacute;m. '+ncrEsc(n.nota_num)):('Solicitud S-'+n.id))
    +' &middot; '+ncrEsc((NCR_ESTADOS[n.estado]||{}).t||n.estado)+'</div>';

  h+='<h2>Tipo de nota</h2>';
  h+=cx(n.tipo==='credito','NOTA DE CREDITO')+cx(n.tipo==='debito','NOTA DE DEBITO');

  h+='<h2>Indicar el motivo de la nota</h2>';
  motivos.forEach(function(m){ h+=cx(n.motivo===m, m); });

  h+='<h2>Indicar el grupo a aplicar</h2>';
  NCR_GRUPOS.forEach(function(g){ h+=cx(n.grupo===g.v, g.v+'  '+g.t); });

  h+='<h2>Generales del documento</h2>';
  h+='<table class="gen"><tr><td style="width:50%">'
    +'<b>FECHA:</b> '+fmtD(n.creado_en)+'<br>'
    +'<b>CODIGO:</b> '+ncrEsc(n.cardcode||'')+'<br>'
    +'<b>NUMERO FACT.:</b> '+(n.docnum||'\u2014')+'<br>'
    +'<b>MONTO $:</b> '+ncrMon(n.monto)
    +'</td><td style="width:50%">'
    +'<b>NOMBRE:</b> '+ncrEsc(n.cardname||'')+'<br>'
    +'<b>PAIS:</b> '+ncrEsc(n.pais||'')+'<br>'
    +'<b>VENDEDOR:</b> '+ncrEsc(n.vendedor||'')+'<br>'
    +'<b>NUM. NOTA:</b> '+ncrEsc(n.nota_num||'________')
    +'</td></tr></table>';

  if(lin.length){
    h+='<h2>Detalle de art\u00edculos</h2>';
    h+='<table><tr><th>#</th><th>SKU</th><th>Descripci&oacute;n</th><th class="r">Fact.</th>'
      +'<th class="r">Afect.</th><th class="r">Precio</th><th class="r">Monto</th>'
      +'<th>Condici&oacute;n</th><th>Observaci&oacute;n</th></tr>';
    lin.forEach(function(l,i){
      h+='<tr><td>'+(i+1)+'</td><td>'+ncrEsc(l.itemcode)+'</td><td>'+ncrEsc(l.dscription)+'</td>'
        +'<td class="r">'+ncrNum(l.cant_facturada).toLocaleString('en-US')+'</td>'
        +'<td class="r"><b>'+ncrNum(l.cant_afectada).toLocaleString('en-US')+'</b></td>'
        +'<td class="r">'+ncrMon(l.precio)+'</td>'
        +'<td class="r"><b>'+ncrMon(l.monto)+'</b></td>'
        +'<td>'+ncrEsc(l.condicion||'')+'</td><td>'+ncrEsc(l.nota||'')+'</td></tr>';
    });
    h+='</table>';
  }
  h+='<div class="tot">TOTAL DE LA NOTA: '+ncrMon(n.monto)+'</div>';

  h+='<h2>Comentarios</h2>';
  h+='<div style="border:1px solid #ddd;min-height:44px;padding:6px 8px;white-space:pre-wrap">'
    +ncrEsc(n.comentarios||'')+'</div>';

  h+='<h2>Firmas</h2>';
  h+='<table><tr><th>SOLICITADO POR</th><th>REVISADO POR</th><th>APROBADO POR</th></tr>'
    +'<tr><td class="firma">'+ncrEsc(n.solicitado_por||'')+'</td>'
    +'<td class="firma">'+ncrEsc(n.revisado_por||'')+'</td>'
    +'<td class="firma">'+ncrEsc(n.aprobado_por||'')+'</td></tr></table>';

  h+='<div class="nota"><b>NOTA:</b> Toda nota debe ser impresa y anexada a este formulario. '
    +'Las notas de cr&eacute;dito por inventario no necesitan escoger el grupo a aplicar: '
    +'el sistema lo hace autom&aacute;ticamente.</div>';

  h+='</body></html>';
  w.document.open(); w.document.write(h); w.document.close();
  setTimeout(function(){ try{ w.focus(); w.print(); }catch(e){} }, 700);
}


/* ══════════════════════════════════════════════════════════════════════════
   DESCARGA EN PDF
   ---------------------------------------------------------------------------
   La ventana de impresion de arriba sirve para imprimir, pero deja el archivo
   en manos del navegador. Aqui se dibuja el PDF de verdad con jsPDF y se
   descarga con nombre propio, para poder adjuntarlo por correo o guardarlo.

   Se reutiliza el cargador del catalogo (catCargarLib): son 350 KB que no
   hace falta bajar hasta que alguien pulsa el boton.
   ══════════════════════════════════════════════════════════════════════════ */

// Descarga una imagen y la deja en base64 con sus dimensiones, que es lo que
// necesita jsPDF para encajarla sin deformarla. Se usa un <img> en vez de leer
// las cabeceras del archivo porque asi el navegador resuelve solo cualquier
// formato que sepa mostrar (incluido HEIC en Safari, que es lo que sale de la
// camara del iPhone).
async function ncrImgB64(url){
  var blob = await (await fetch(url, {mode:'cors'})).blob();

  var dataUrl = await new Promise(function(res, rej){
    var fr=new FileReader();
    fr.onload=function(){ res(fr.result); };
    fr.onerror=function(){ rej(new Error('no se pudo leer')); };
    fr.readAsDataURL(blob);
  });

  var dim = await new Promise(function(res, rej){
    var im=new Image();
    im.onload=function(){ res({w:im.naturalWidth||im.width, h:im.naturalHeight||im.height}); };
    im.onerror=function(){ rej(new Error('no se pudo decodificar')); };
    im.src=dataUrl;
  });

  // Solo el JPEG pasa tal cual. Todo lo demas se repinta en un canvas y sale
  // como JPEG, aunque el original sea pequeño: jsPDF incrusta los PNG como RGB
  // sin comprimir, asi que un PNG de 3 KB en disco ocupa 1,5 MB dentro del PDF
  // y con diez fotos el archivo no se puede ni mandar por correo.
  //
  // Ademas se limita el lado mayor a 1400 px (sobra para imprimir) y se
  // recomprime cualquier JPEG que pase de 500 KB.
  var tipo=(blob.type||'').toLowerCase();
  var esJpeg=/jpe?g/.test(tipo);
  var LADO=1400, PESO=500*1024;

  if(esJpeg && Math.max(dim.w,dim.h)<=LADO && (blob.size||0)<=PESO){
    return {data:dataUrl, ext:'JPEG', w:dim.w, h:dim.h};
  }

  var esc = Math.min(1, LADO/Math.max(dim.w, dim.h));
  var cw=Math.round(dim.w*esc), ch=Math.round(dim.h*esc);
  var cv=document.createElement('canvas'); cv.width=cw; cv.height=ch;
  var cx=cv.getContext('2d');
  cx.fillStyle='#fff'; cx.fillRect(0,0,cw,ch);   // fondo para PNG transparentes
  var im2=new Image();
  await new Promise(function(res,rej){ im2.onload=res; im2.onerror=rej; im2.src=dataUrl; });
  cx.drawImage(im2, 0, 0, cw, ch);
  return {data:cv.toDataURL('image/jpeg', 0.82), ext:'JPEG', w:cw, h:ch};
}

var NCR_LIB_URL = 'https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js';
var _ncrLibProm = null;

function ncrCargarLib(){
  if(window.jspdf && window.jspdf.jsPDF) return Promise.resolve();
  // Si el catalogo ya trae su cargador, se usa ese y no se baja dos veces.
  if(typeof catCargarLib === 'function') return catCargarLib();
  if(_ncrLibProm) return _ncrLibProm;
  _ncrLibProm = new Promise(function(res, rej){
    var sc=document.createElement('script');
    sc.src=NCR_LIB_URL;
    sc.onload=function(){ res(); };
    sc.onerror=function(){ _ncrLibProm=null; rej(new Error('No se pudo cargar el generador de PDF')); };
    document.head.appendChild(sc);
  });
  return _ncrLibProm;
}

// Los datos de la ultima nota que se armo en PDF: los usa el correo para
// componer el asunto y el cuerpo sin volver a consultarlos.
var NCR_ENVIO=null;

// Devuelve el PDF como Blob, para descargarlo o para adjuntarlo a un correo.
async function ncrPdfBlob(id){
  var doc=await ncrPdfDoc(id);
  return doc.output('blob');
}

async function ncrDescargar(id){
  try{
    var doc=await ncrPdfDoc(id);
    doc.save(ncrPdfNombre(id));
  }catch(e){
    alert('No se pudo generar el PDF: '+(e&&e.message?e.message:e));
  }
}

function ncrPdfNombre(id){
  var n=NCR_ENVIO||{};
  // Si ya esta en SAP, el nombre lleva SU numero: es el que buscara quien
  // reciba el archivo, no la referencia interna del portal.
  return 'nota-'+(n.tipo==='debito'?'debito':'credito')+'-'
    +(n.docnum_sap ? String(n.docnum_sap)
      : (n.nota_num?String(n.nota_num).replace(/[^\w\-]/g,''):('S'+id)))
    +(n.docnum?('-fact'+n.docnum):'')+'.pdf';
}

async function ncrPdfDoc(id){
  await ncrCargarLib();

  var r=await Promise.all([
    q('solicitudes_nota','select=*&id=eq.'+id+'&limit=1'),
    q('solicitudes_nota_lineas','select=*&nota_id=eq.'+id+'&order=linenum'),
    q('solicitudes_nota_adjuntos','select=*&nota_id=eq.'+id+'&order=id')
  ]);
  var n=(r[0]&&r[0][0])||null, lin=r[1]||[], adj=r[2]||[];
  if(!n) throw new Error('No encontr\u00e9 la nota S-'+id);
  NCR_ENVIO=n;

  var jsPDF=window.jspdf.jsPDF;
  var doc=new jsPDF({unit:'pt', format:'letter'});
  var W=doc.internal.pageSize.getWidth();      // 612
  var H=doc.internal.pageSize.getHeight();     // 792
  var M=40, y=0;

  function pag(){
    var d=new Date();
    var f=('0'+d.getDate()).slice(-2)+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+d.getFullYear();
    doc.setFont('helvetica','normal'); doc.setFontSize(7); doc.setTextColor(140,140,140);
    doc.text('Kennedy Center Corp.  \u00b7  Documento interno  \u00b7  generado el '+f, M, H-24);
  }
  function salto(alto){
    if(y+alto <= H-46) return;
    pag(); doc.addPage(); y=M;
  }
  // Banda gris de seccion, como los encabezados del formulario en papel.
  function banda(txt){
    salto(30); y+=8;
    doc.setFillColor(233,233,233); doc.setDrawColor(180,180,180);
    doc.rect(M, y, W-2*M, 16, 'FD');
    doc.setFont('helvetica','bold'); doc.setFontSize(8.5); doc.setTextColor(30,30,30);
    doc.text(String(txt).toUpperCase(), M+6, y+11);
    y+=16+8;
  }
  // Casilla marcada o vacia + su texto. Tres por fila.
  function casillas(items, marcado){
    var cols=3, cw=(W-2*M)/cols, fila=14, i=0;
    while(i<items.length){
      salto(fila);
      for(var c=0;c<cols && i<items.length;c++,i++){
        var x=M+c*cw, on=marcado(items[i]);
        doc.setDrawColor(60,60,60); doc.setLineWidth(.7);
        doc.rect(x, y-7.5, 8.5, 8.5);
        if(on){
          doc.setFont('helvetica','bold'); doc.setFontSize(7.5); doc.setTextColor(0,0,0);
          doc.text('X', x+2, y-1.3);
        }
        doc.setFont('helvetica', on?'bold':'normal'); doc.setFontSize(7.6);
        doc.setTextColor(on?0:70, on?0:70, on?0:70);
        doc.text(doc.splitTextToSize(String(items[i]), cw-16)[0], x+13, y-1);
      }
      y+=fila;
    }
    y+=4;
  }
  function campo(x, etiqueta, valor, ancho){
    doc.setFont('helvetica','bold'); doc.setFontSize(7.8); doc.setTextColor(90,90,90);
    doc.text(etiqueta, x, y);
    doc.setFont('helvetica','normal'); doc.setFontSize(9); doc.setTextColor(20,20,20);
    doc.text(doc.splitTextToSize(String(valor==null?'':valor)||'\u2014', ancho-92)[0], x+92, y);
  }

  // ── Encabezado ────────────────────────────────────────────────────────────
  y=M+4;
  doc.setFont('helvetica','bold'); doc.setFontSize(15); doc.setTextColor(15,15,15);
  doc.text('KENNEDY CENTER CORP.', M, y);
  y+=15;
  doc.setFont('helvetica','normal'); doc.setFontSize(9.5); doc.setTextColor(85,85,85);
  var est=(NCR_ESTADOS[n.estado]||{}).t||n.estado;
  doc.text('Solicitud de nota  \u00b7  '
    + (n.nota_num ? ('N\u00fam. '+n.nota_num) : ('Solicitud S-'+n.id))
    + '  \u00b7  ' + est, M, y);

  // El numero que le dio SAP, en grande y a la derecha.
  //
  // Es el unico que sirve fuera del portal: para contabilidad, para el
  // cliente y para buscarla en SAP. Mientras no se haya mandado no existe,
  // asi que solo aparece cuando lo hay.
  if(n.docnum_sap){
    doc.setFont('helvetica','bold'); doc.setFontSize(13);
    doc.setTextColor(15,15,15);
    doc.text((n.tipo==='debito' ? 'Nota de d\u00e9bito ' : 'Nota de cr\u00e9dito ')
             + n.docnum_sap, W-M, y, {align:'right'});
    doc.setFont('helvetica','normal'); doc.setFontSize(9.5);
    doc.setTextColor(85,85,85);
  }
  y+=6;
  doc.setDrawColor(150,150,150); doc.setLineWidth(1);
  doc.line(M, y, W-M, y);
  y+=4;

  // ── Tipo ──────────────────────────────────────────────────────────────────
  banda('Tipo de nota');
  casillas(['NOTA DE CREDITO','NOTA DE DEBITO'], function(t){
    return (t==='NOTA DE CREDITO') === (n.tipo==='credito');
  });

  // ── Motivo ────────────────────────────────────────────────────────────────
  banda('Indicar el motivo de la nota');
  casillas((n.tipo==='debito')?NCR_MOTIVOS_DEBITO:NCR_MOTIVOS_CREDITO, function(m){
    return m===n.motivo;
  });

  // ── Grupo ─────────────────────────────────────────────────────────────────
  banda('Indicar el grupo a aplicar');
  casillas(NCR_GRUPOS.map(function(g){ return g.v+'  '+g.t; }), function(t){
    return t.indexOf(String(n.grupo||'\u0000'))===0;
  });

  // ── Generales ─────────────────────────────────────────────────────────────
  banda('Generales del documento');
  var col=(W-2*M)/2, izq=M, der=M+col;
  var izqDatos=[['FECHA:', fmtD(n.creado_en)],
                ['CODIGO:', n.cardcode],
                ['NUMERO FACT.:', n.docnum||'\u2014'],
                ['MONTO $:', ncrMon(n.monto)]];
  var derDatos=[['NOMBRE:', n.cardname],
                ['PAIS:', n.pais],
                ['VENDEDOR:', n.vendedor],
                ['NUM. NOTA:', n.nota_num||'________']];
  for(var i=0;i<4;i++){
    salto(15);
    campo(izq, izqDatos[i][0], izqDatos[i][1], col);
    campo(der, derDatos[i][0], derDatos[i][1], col);
    y+=15;
  }
  y+=4;

  // ── Detalle ───────────────────────────────────────────────────────────────
  if(lin.length){
    banda('Detalle de art\u00edculos');
    // SKU, descripcion, facturado, afectado, precio, monto, condicion
    var anchos=[62, 158, 42, 42, 52, 58, 118];
    function cabecera(){
      salto(18);
      doc.setFillColor(236,236,236); doc.setDrawColor(180,180,180); doc.setLineWidth(.5);
      doc.rect(M, y, W-2*M, 15, 'FD');
      doc.setFont('helvetica','bold'); doc.setFontSize(7.2); doc.setTextColor(40,40,40);
      var hs=['SKU','DESCRIPCION','FACT.','AFECT.','PRECIO','MONTO','CONDICION'], x=M;
      hs.forEach(function(t,k){
        var der=(k>=2&&k<=5);
        doc.text(t, der?(x+anchos[k]-4):(x+4), y+10, {align:der?'right':'left'});
        x+=anchos[k];
      });
      y+=15;
    }
    cabecera();
    lin.forEach(function(l){
      var desc=doc.splitTextToSize(String(l.dscription||''), anchos[1]-8).slice(0,2);
      var cond=doc.splitTextToSize(
        String(l.condicion||'') + (l.nota?('  \u2014 '+l.nota):''), anchos[6]-8).slice(0,2);
      var alto=Math.max(desc.length, cond.length)*9 + 7;
      if(y+alto > H-46){ pag(); doc.addPage(); y=M; cabecera(); }
      doc.setDrawColor(220,220,220); doc.setLineWidth(.4);
      doc.rect(M, y, W-2*M, alto);
      doc.setFont('helvetica','normal'); doc.setFontSize(7.4); doc.setTextColor(25,25,25);
      var x=M;
      doc.text(String(l.itemcode||''), x+4, y+9.5); x+=anchos[0];
      doc.text(desc, x+4, y+9.5); x+=anchos[1];
      doc.text(ncrNum(l.cant_facturada).toLocaleString('en-US'), x+anchos[2]-4, y+9.5, {align:'right'}); x+=anchos[2];
      doc.setFont('helvetica','bold');
      doc.text(ncrNum(l.cant_afectada).toLocaleString('en-US'), x+anchos[3]-4, y+9.5, {align:'right'}); x+=anchos[3];
      doc.setFont('helvetica','normal');
      doc.text(ncrMon(l.precio), x+anchos[4]-4, y+9.5, {align:'right'}); x+=anchos[4];
      doc.setFont('helvetica','bold');
      doc.text(ncrMon(l.monto), x+anchos[5]-4, y+9.5, {align:'right'}); x+=anchos[5];
      doc.setFont('helvetica','normal'); doc.setFontSize(6.8); doc.setTextColor(70,70,70);
      doc.text(cond, x+4, y+9.5);
      y+=alto;
    });
    y+=2;
  }

  // ── Total ─────────────────────────────────────────────────────────────────
  salto(24);
  doc.setFont('helvetica','bold'); doc.setFontSize(12); doc.setTextColor(15,15,15);
  doc.text('TOTAL DE LA NOTA:  '+ncrMon(n.monto), W-M, y+12, {align:'right'});
  y+=24;

  // ── Motivo ────────────────────────────────────────────────────────────────
  // Igual que el PDF que imprime SAP: va debajo del total y antes de las
  // firmas. Es el dato que contabilidad necesita para archivar la nota, y
  // en SAP se guarda en `ORIN.TrnspCode`.
  if(n.motivo){
    salto(18);
    doc.setFont('helvetica','bold'); doc.setFontSize(9.5);
    doc.setTextColor(15,15,15);
    doc.text('Motivo:', M, y+10);
    doc.setFont('helvetica','normal');
    doc.text(String(n.motivo), M+44, y+10);
    y+=20;
  }

  // ── Comentarios ───────────────────────────────────────────────────────────
  banda('Comentarios');
  var com=doc.splitTextToSize(String(n.comentarios||''), W-2*M-12);
  var altoCom=Math.max(40, com.length*10+12);
  salto(altoCom);
  doc.setDrawColor(200,200,200); doc.setLineWidth(.5);
  doc.rect(M, y, W-2*M, altoCom);
  doc.setFont('helvetica','normal'); doc.setFontSize(8.5); doc.setTextColor(35,35,35);
  if(com.length) doc.text(com, M+6, y+13);
  y+=altoCom+4;

  // ── Firmas ────────────────────────────────────────────────────────────────
  banda('Firmas');
  salto(64);
  var fw=(W-2*M)/3;
  [['SOLICITADO POR', n.solicitado_por],
   ['REVISADO POR',   n.revisado_por],
   ['APROBADO POR',   n.aprobado_por]].forEach(function(f,k){
    var x=M+k*fw;
    doc.setDrawColor(180,180,180); doc.setLineWidth(.6);
    doc.rect(x, y, fw, 60);
    doc.setFont('helvetica','bold'); doc.setFontSize(7.2); doc.setTextColor(90,90,90);
    doc.text(f[0], x+6, y+11);
    doc.setFont('helvetica','normal'); doc.setFontSize(8.5); doc.setTextColor(25,25,25);
    doc.text(doc.splitTextToSize(String(f[1]||''), fw-12).slice(0,2), x+6, y+50);
  });
  y+=60+8;

  // ── Adjuntos ──────────────────────────────────────────────────────────────
  // Las imagenes se incrustan de verdad: si el formulario se archiva en papel,
  // la constancia tiene que ir dentro del documento y no en un enlace.
  if(adj.length){
    banda('Adjuntos del reclamo ('+adj.length+')');

    var imgs = adj.filter(function(a){ return ncrEsImagen(a.mime,a.nombre); });
    var docs = adj.filter(function(a){ return !ncrEsImagen(a.mime,a.nombre); });

    // Los que no son imagenes solo se listan: no hay forma de incrustar un PDF
    // ajeno ni un correo dentro de este.
    docs.forEach(function(a){
      salto(13);
      doc.setFont('helvetica','normal'); doc.setFontSize(8);  doc.setTextColor(35,35,35);
      doc.text('\u2022 '+a.nombre+(a.descripcion?('  \u2014 '+a.descripcion):''), M+2, y+8);
      y+=13;
    });
    if(docs.length) y+=4;

    // Dos por fila, 12 como maximo para no inflar el archivo.
    var cols=2, cw=(W-2*M)/cols, ih=150, tope=Math.min(imgs.length,12), col=0;
    for(var ai=0; ai<tope; ai++){
      if(col===0) salto(ih+22);
      var a=imgs[ai], x=M+col*cw;
      var b64=null;
      try{ b64 = await ncrImgB64(a.url); }catch(e){ b64=null; }
      doc.setDrawColor(200,200,200); doc.setLineWidth(.5);
      doc.rect(x, y, cw-8, ih);
      if(b64 && b64.data){
        // Se encaja dentro del marco conservando la proporcion.
        var maxW=cw-16, maxH=ih-10;
        var esc=Math.min(maxW/b64.w, maxH/b64.h);
        var w2=b64.w*esc, h2=b64.h*esc;
        try{
          doc.addImage(b64.data, b64.ext, x+(cw-8-w2)/2, y+(ih-h2)/2, w2, h2);
        }catch(e){}
      } else {
        doc.setFont('helvetica','normal'); doc.setFontSize(7.5); doc.setTextColor(150,150,150);
        doc.text('(no se pudo cargar la imagen)', x+8, y+ih/2);
      }
      doc.setFont('helvetica','normal'); doc.setFontSize(7); doc.setTextColor(70,70,70);
      doc.text(doc.splitTextToSize(
        a.nombre+(a.descripcion?('  \u2014 '+a.descripcion):''), cw-14).slice(0,2),
        x+2, y+ih+9);
      col++;
      if(col>=cols){ col=0; y+=ih+22; }
    }
    if(col>0) y+=ih+22;
    if(imgs.length>tope){
      salto(13);
      doc.setFont('helvetica','italic'); doc.setFontSize(7.5); doc.setTextColor(110,110,110);
      doc.text('Se incluyen las primeras '+tope+' de '+imgs.length
        +' im\u00e1genes. El resto est\u00e1 en el portal.', M+2, y+8);
      y+=13;
    }
  }

  // ── Pie ───────────────────────────────────────────────────────────────────
  salto(28);
  doc.setFont('helvetica','normal'); doc.setFontSize(7); doc.setTextColor(90,90,90);
  doc.text(doc.splitTextToSize(
    'NOTA: Toda nota debe ser impresa y anexada a este formulario. Las notas de '
    + 'cr\u00e9dito por inventario no necesitan escoger el grupo a aplicar: el sistema '
    + 'lo hace autom\u00e1ticamente.', W-2*M), M, y+8);
  pag();

  return doc;
}
